// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type ClientMeta, formDataBodySerializer, type Options as Options2, type RequestResult, type TDataShape } from './client';
import { client } from './client.gen';
import type { AcceptInvitationData, AcceptInvitationErrors, AcceptInvitationResponses, AcknowledgeLoginActivityData, AcknowledgeLoginActivityErrors, AcknowledgeLoginActivityResponses, AutocompleteAddressData, AutocompleteAddressErrors, AutocompleteAddressResponses, ChangePasswordData, ChangePasswordErrors, ChangePasswordResponses, ChangePortalUserRoleData, ChangePortalUserRoleErrors, ChangePortalUserRoleResponses, ClearAdvocacyHistoryData, ClearAdvocacyHistoryResponses, ClearPersonFieldOverrideData, ClearPersonFieldOverrideErrors, ClearPersonFieldOverrideResponses, CourtlistenerWebhookData, CourtlistenerWebhookErrors, CourtlistenerWebhookResponses, CreateConfigData, CreateConfigErrors, CreateConfigResponses, CreateInquiryData, CreateInquiryErrors, CreateInquiryResponses, CreateOrganizationData, CreateOrganizationErrors, CreateOrganizationResponses, DebugPersonalizedScoringData, DebugPersonalizedScoringErrors, DebugPersonalizedScoringResponses, DeleteAccountData, DeleteAccountErrors, DeleteAccountResponses, DeleteConfigData, DeleteConfigErrors, DeleteConfigResponses, DeleteOrganizationData, DeleteOrganizationErrors, DeleteOrganizationResponses, ForgotPasswordData, ForgotPasswordErrors, ForgotPasswordResponses, GenerateFeedForUserData, GenerateFeedForUserErrors, GenerateFeedForUserResponses, GenerateRecommendationsData, GenerateRecommendationsErrors, GenerateRecommendationsResponses, GetAccessTokenData, GetAccessTokenErrors, GetAccessTokenResponses, GetAiRecommendationsData, GetAiRecommendationsErrors, GetAiRecommendationsResponses, GetAllBallotTrackingData, GetAllBallotTrackingResponses, GetAllRecommendationsData, GetAllRecommendationsResponses, GetAllTrendingTopicsData, GetAllTrendingTopicsResponses, GetAnalyticsPreferenceData, GetAnalyticsPreferenceResponses, GetBallotStatusData, GetBallotStatusErrors, GetBallotStatusResponses, GetBatchStatusData, GetBatchStatusErrors, GetBatchStatusResponses, GetBillsData, GetBillsErrors, GetBillsResponses, GetCandidatesData, GetCandidatesResponses, GetCitiesData, GetCitiesErrors, GetCitiesResponses, GetConfigData, GetConfigErrors, GetConfigResponses, GetContactRecoveryData, GetContactRecoveryResponses, GetCountiesData, GetCountiesErrors, GetCountiesResponses, GetCurrentPresidentBillsData, GetCurrentPresidentBillsErrors, GetCurrentPresidentBillsResponses, GetCurrentPresidentExecutiveOrdersData, GetCurrentPresidentExecutiveOrdersErrors, GetCurrentPresidentExecutiveOrdersResponses, GetCurrentVerificationStatusData, GetCurrentVerificationStatusResponses, GetDashboardData, GetDashboardResponses, GetElectedOfficialsData, GetElectedOfficialsResponses, GetElectionDetailsData, GetElectionDetailsResponses, GetExecutiveOrdersData, GetExecutiveOrdersErrors, GetExecutiveOrdersResponses, GetFederalOfficialsData, GetFederalOfficialsErrors, GetFederalOfficialsResponses, GetFeedItemDetailData, GetFeedItemDetailErrors, GetFeedItemDetailResponses, GetLatestTaskData, GetLatestTaskErrors, GetLatestTaskResponses, GetLocalOfficialsData, GetLocalOfficialsErrors, GetLocalOfficialsResponses, GetLoginActivityData, GetLoginActivityErrors, GetLoginActivityResponses, GetLoginAlertPreferenceData, GetLoginAlertPreferenceResponses, GetMainFeedData, GetMainFeedErrors, GetMainFeedResponses, GetMyProfileData, GetMyProfileResponses, GetMyRecommendationsData, GetMyRecommendationsErrors, GetMyRecommendationsResponses, GetMyTasksData, GetMyTasksErrors, GetMyTasksResponses, GetOnboardingSurveyData, GetOnboardingSurveyResponses, GetOrFetchBillData, GetOrFetchBillErrors, GetOrFetchBillResponses, GetOrganizationData, GetOrganizationErrors, GetOrganizationResponses, GetPavStatusData, GetPavStatusResponses, GetPendingRecommendationsData, GetPendingRecommendationsResponses, GetPendingTrendingTopicsData, GetPendingTrendingTopicsResponses, GetPersonOverridesData, GetPersonOverridesErrors, GetPersonOverridesResponses, GetPollingPlacesData, GetPollingPlacesErrors, GetPollingPlacesResponses, GetProfileData, GetProfileResponses, GetRecommendationsPreferenceData, GetRecommendationsPreferenceResponses, GetRecommendedResearchData, GetRecommendedResearchErrors, GetRecommendedResearchResponses, GetRegionsData, GetRegionsErrors, GetRegionsResponses, GetSessionsData, GetSessionsResponses, GetStateElectionResourceData, GetStateElectionResourceResponses, GetStateOfficialsData, GetStateOfficialsErrors, GetStateOfficialsResponses, GetSupportContactInfoData, GetSupportContactInfoResponses, GetTaskStatusData, GetTaskStatusErrors, GetTaskStatusResponses, GetTrackedItemsData, GetTrackedItemsErrors, GetTrackedItemsResponses, GetUpcomingElectionsData, GetUpcomingElectionsErrors, GetUpcomingElectionsResponses, GetUserProfileDebugData, GetUserProfileDebugResponses, GetVoterRecordData, GetVoterRecordResponses, GetVotingMethodData, GetVotingMethodResponses, GetVotingModuleAggregateData, GetVotingModuleAggregateResponses, GetWarningStatusData, GetWarningStatusResponses, GetZipcodesData, GetZipcodesErrors, GetZipcodesResponses, HealthCheckHealthGetData, HealthCheckHealthGetResponses, IngestCandidatesData, IngestCandidatesErrors, IngestCandidatesResponses, IngestElectionsData, IngestElectionsErrors, IngestElectionsResponses, IngestUserOfficialsData, IngestUserOfficialsErrors, IngestUserOfficialsResponses, InviteOrganizationSuperAdminData, InviteOrganizationSuperAdminErrors, InviteOrganizationSuperAdminResponses, InvitePortalUserData, InvitePortalUserErrors, InvitePortalUserResponses, LinkVoterRecordData, LinkVoterRecordResponses, ListConfigsData, ListConfigsResponses, ListOrganizationPortalUsersData, ListOrganizationPortalUsersErrors, ListOrganizationPortalUsersResponses, ListOrganizationsData, ListOrganizationsErrors, ListOrganizationsResponses, ListPortalUsersData, ListPortalUsersErrors, ListPortalUsersResponses, LogActionData, LogActionErrors, LogActionResponses, LoginData, LoginErrors, LoginResponses, LogoutData, LogoutErrors, LogoutResponses, LookUpInvitationData, LookUpInvitationErrors, LookUpInvitationResponses, LookupVoterbaseIdData, LookupVoterbaseIdErrors, LookupVoterbaseIdResponses, MapVoterbaseIdData, MapVoterbaseIdErrors, MapVoterbaseIdResponses, MarkBallotRequestCompletedData, MarkBallotRequestCompletedErrors, MarkBallotRequestCompletedResponses, MarkPavRequestCompletedData, MarkPavRequestCompletedResponses, MfaVerifyData, MfaVerifyErrors, MfaVerifyResponses, PortalActivityActorsData, PortalActivityActorsErrors, PortalActivityActorsResponses, PortalActivityData, PortalActivityErrors, PortalActivityResponses, PortalForgotPasswordData, PortalForgotPasswordErrors, PortalForgotPasswordResponses, PortalLoginData, PortalLoginErrors, PortalLoginResponses, PortalLogoutData, PortalLogoutResponses, PortalMeData, PortalMeResponses, PortalRefreshData, PortalRefreshErrors, PortalRefreshResponses, PortalResetPasswordData, PortalResetPasswordErrors, PortalResetPasswordResponses, PortalSendCodeData, PortalSendCodeErrors, PortalSendCodeResponses, PortalVerifyData, PortalVerifyErrors, PortalVerifyResponses, ProcessBatchData, ProcessBatchErrors, ProcessBatchResponses, ProcessSingleEntityData, ProcessSingleEntityErrors, ProcessSingleEntityResponses, ReadBillingData, ReadBillingErrors, ReadBillingResponses, ReadNotificationAllowanceData, ReadNotificationAllowanceErrors, ReadNotificationAllowanceResponses, ReadOrganizationNotificationAllowanceData, ReadOrganizationNotificationAllowanceErrors, ReadOrganizationNotificationAllowanceResponses, ReadProfileData, ReadProfileErrors, ReadProfileResponses, ReceiveWebhookData, ReceiveWebhookResponses, RefreshOfficialData, RefreshOfficialErrors, RefreshOfficialResponses, RefreshUserOfficialsData, RefreshUserOfficialsErrors, RefreshUserOfficialsResponses, RegisterDeviceTokenData, RegisterDeviceTokenErrors, RegisterDeviceTokenResponses, RemoveCoverImageData, RemoveCoverImageErrors, RemoveCoverImageResponses, RemoveDeviceTokenData, RemoveDeviceTokenErrors, RemoveDeviceTokenResponses, RemoveLogoData, RemoveLogoErrors, RemoveLogoResponses, RemovePortalUserData, RemovePortalUserErrors, RemovePortalUserResponses, ResendMfaCodeData, ResendMfaCodeErrors, ResendMfaCodeResponses, ResendOrganizationInvitationData, ResendOrganizationInvitationErrors, ResendOrganizationInvitationResponses, ResendPortalInvitationData, ResendPortalInvitationErrors, ResendPortalInvitationResponses, ResetPasswordData, ResetPasswordErrors, ResetPasswordResponses, RevokeAllSessionsData, RevokeAllSessionsResponses, RevokeOrganizationInvitationData, RevokeOrganizationInvitationErrors, RevokeOrganizationInvitationResponses, RevokePortalInvitationData, RevokePortalInvitationErrors, RevokePortalInvitationResponses, RevokeSessionData, RevokeSessionErrors, RevokeSessionResponses, RootGetData, RootGetResponses, SearchResearchData, SearchResearchErrors, SearchResearchResponses, SendMfaCodeData, SendMfaCodeErrors, SendMfaCodeResponses, SetPersonFieldOverrideData, SetPersonFieldOverrideErrors, SetPersonFieldOverrideResponses, SignupBasicDetailsData, SignupBasicDetailsErrors, SignupBasicDetailsResponses, SignUpData, SignUpErrors, SignupPreviewData, SignupPreviewErrors, SignupPreviewResponses, SignupPreviewUpdateData, SignupPreviewUpdateErrors, SignupPreviewUpdateResponses, SignUpResponses, SignupStep2Data, SignupStep2Errors, SignupStep2Responses, StaffActivityActorsData, StaffActivityActorsErrors, StaffActivityActorsResponses, StaffActivityData, StaffActivityErrors, StaffActivityResponses, StaffOrganizationActivityActorsData, StaffOrganizationActivityActorsErrors, StaffOrganizationActivityActorsResponses, StaffOrganizationActivityData, StaffOrganizationActivityErrors, StaffOrganizationActivityResponses, SubmitBugReportData, SubmitBugReportErrors, SubmitBugReportResponses, SubmitContactRequestData, SubmitContactRequestErrors, SubmitContactRequestResponses, SubmitSurveyData, SubmitSurveyErrors, SubmitSurveyResponses, ToggleFavoriteData, ToggleFavoriteErrors, ToggleFavoriteResponses, ToggleFollowData, ToggleFollowErrors, ToggleFollowResponses, TrackItemData, TrackItemErrors, TrackItemResponses, TriggerDryRunSyncData, TriggerDryRunSyncErrors, TriggerDryRunSyncResponses, UnlinkVoterRecordByIdData, UnlinkVoterRecordByIdErrors, UnlinkVoterRecordByIdResponses, UnlinkVoterRecordData, UnlinkVoterRecordResponses, UntrackItemData, UntrackItemErrors, UntrackItemResponses, UpdateAnalyticsPreferenceData, UpdateAnalyticsPreferenceErrors, UpdateAnalyticsPreferenceResponses, UpdateBillingContactData, UpdateBillingContactErrors, UpdateBillingContactResponses, UpdateConfigData, UpdateConfigErrors, UpdateConfigResponses, UpdateEmailData, UpdateEmailErrors, UpdateEmailResponses, UpdateGovernmentIdData, UpdateGovernmentIdErrors, UpdateGovernmentIdResponses, UpdateLoginAlertPreferenceData, UpdateLoginAlertPreferenceErrors, UpdateLoginAlertPreferenceResponses, UpdateMyProfileData, UpdateMyProfileErrors, UpdateMyProfileResponses, UpdateOrganizationData, UpdateOrganizationErrors, UpdateOrganizationResponses, UpdatePhoneData, UpdatePhoneErrors, UpdatePhoneResponses, UpdateProfileData, UpdateProfileErrors, UpdateProfilePictureData, UpdateProfilePictureErrors, UpdateProfilePictureResponses, UpdateProfileResponses, UpdateRecommendationData, UpdateRecommendationErrors, UpdateRecommendationResponses, UpdateRecommendationsPreferenceData, UpdateRecommendationsPreferenceErrors, UpdateRecommendationsPreferenceResponses, UpdateSelfieData, UpdateSelfieErrors, UpdateSelfieResponses, UpdateTrendingTopicData, UpdateTrendingTopicErrors, UpdateTrendingTopicMatchData, UpdateTrendingTopicMatchErrors, UpdateTrendingTopicMatchResponses, UpdateTrendingTopicResponses, UpdateVotingMethodData, UpdateVotingMethodErrors, UpdateVotingMethodResponses, UploadCoverImageData, UploadCoverImageErrors, UploadCoverImageResponses, UploadLogoData, UploadLogoErrors, UploadLogoResponses, UploadSignupGovernmentIdData, UploadSignupGovernmentIdErrors, UploadSignupGovernmentIdResponses, UploadSignupProfilePictureData, UploadSignupProfilePictureErrors, UploadSignupProfilePictureResponses, UploadSignupSelfieData, UploadSignupSelfieErrors, UploadSignupSelfieResponses, VerifyIdentityData, VerifyIdentityErrors, VerifyIdentityResponses, VoterLinkData, VoterLinkErrors, VoterLinkResponses, VoterLookupData, VoterLookupErrors, VoterLookupResponses, WebhookHealthData, WebhookHealthResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Root
 *
 * Root endpoint - Health check
 */
export const rootGet = <ThrowOnError extends boolean = false>(options?: Options<RootGetData, ThrowOnError>): RequestResult<RootGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<RootGetResponses, unknown, ThrowOnError>({ url: '/', ...options });

/**
 * Log a Civic Action (Call or Email)
 *
 * Log that the current user made a call or sent an email to an elected official.
 *
 * - **official_id** *(optional)*: UUID of the official in the research_people table
 * - **official_name** *(optional)*: Display name of the official (denormalized)
 * - **action_type**: `"CALL"` or `"EMAIL"`
 *
 * **Authentication Required** — Bearer token in Authorization header.
 */
export const logAction = <ThrowOnError extends boolean = false>(options: Options<LogActionData, ThrowOnError>): RequestResult<LogActionResponses, LogActionErrors, ThrowOnError> => (options.client ?? client).post<LogActionResponses, LogActionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/actions/log',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Autocomplete Address
 *
 * US address autocomplete for the signup form.
 *
 * Proxies the Mapbox Geocoding v6 API so the access token stays server-side.
 * Queries shorter than 3 characters (and any Mapbox failure) return an empty
 * list rather than an error — the app falls back to manual address entry.
 */
export const autocompleteAddress = <ThrowOnError extends boolean = false>(options: Options<AutocompleteAddressData, ThrowOnError>): RequestResult<AutocompleteAddressResponses, AutocompleteAddressErrors, ThrowOnError> => (options.client ?? client).get<AutocompleteAddressResponses, AutocompleteAddressErrors, ThrowOnError>({ url: '/activist-arc/address/autocomplete', ...options });

/**
 * Get Cities
 */
export const getCities = <ThrowOnError extends boolean = false>(options?: Options<GetCitiesData, ThrowOnError>): RequestResult<GetCitiesResponses, GetCitiesErrors, ThrowOnError> => (options?.client ?? client).get<GetCitiesResponses, GetCitiesErrors, ThrowOnError>({ url: '/activist-arc/address/cities', ...options });

/**
 * Get Counties
 */
export const getCounties = <ThrowOnError extends boolean = false>(options?: Options<GetCountiesData, ThrowOnError>): RequestResult<GetCountiesResponses, GetCountiesErrors, ThrowOnError> => (options?.client ?? client).get<GetCountiesResponses, GetCountiesErrors, ThrowOnError>({ url: '/activist-arc/address/counties', ...options });

/**
 * Get Regions
 */
export const getRegions = <ThrowOnError extends boolean = false>(options?: Options<GetRegionsData, ThrowOnError>): RequestResult<GetRegionsResponses, GetRegionsErrors, ThrowOnError> => (options?.client ?? client).get<GetRegionsResponses, GetRegionsErrors, ThrowOnError>({ url: '/activist-arc/address/regions', ...options });

/**
 * Get Zipcodes
 *
 * Get zipcodes filtered by region (state) or county.
 *
 * Priority order:
 * - If county_id is provided: Returns zipcodes for that specific county
 * - If only region_id is provided: Returns ALL zipcodes for all counties in that state
 * - If neither is provided: Returns all zipcodes (may be very large)
 * - search parameter can be combined with any of the above filters
 *
 * Example usage:
 * - GET /zipcodes?region_id=33 - All zipcodes in NY state
 * - GET /zipcodes?county_id=123 - All zipcodes in specific county
 * - GET /zipcodes?region_id=33&search=100 - All NY zipcodes starting with 100
 */
export const getZipcodes = <ThrowOnError extends boolean = false>(options?: Options<GetZipcodesData, ThrowOnError>): RequestResult<GetZipcodesResponses, GetZipcodesErrors, ThrowOnError> => (options?.client ?? client).get<GetZipcodesResponses, GetZipcodesErrors, ThrowOnError>({ url: '/activist-arc/address/zipcodes', ...options });

/**
 * Generate Recommendations
 *
 * Generate AI-driven recommendations for a specific user.
 *
 * This endpoint:
 * - Analyzes user's survey responses and behavioral data (favorites, follows)
 * - Uses OpenAI to generate smart search queries
 * - Searches Congress.gov, OpenStates, CourtListener, and other APIs
 * - Stores recommendations for admin approval
 *
 * Recommendations are created as unpublished (is_published=False) and
 * require admin review before appearing to the user.
 */
export const generateRecommendations = <ThrowOnError extends boolean = false>(options: Options<GenerateRecommendationsData, ThrowOnError>): RequestResult<GenerateRecommendationsResponses, GenerateRecommendationsErrors, ThrowOnError> => (options.client ?? client).post<GenerateRecommendationsResponses, GenerateRecommendationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/generate-recommendations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ingest Candidates
 *
 * Trigger manual ingestion of candidates for a specific activist by their ID.
 * Looks up the activist's address and fetches upcoming elections and candidates from BallotReady.
 *
 * This will create ResearchPerson records with ballot_ready_id properly set.
 */
export const ingestCandidates = <ThrowOnError extends boolean = false>(options: Options<IngestCandidatesData, ThrowOnError>): RequestResult<IngestCandidatesResponses, IngestCandidatesErrors, ThrowOnError> => (options.client ?? client).post<IngestCandidatesResponses, IngestCandidatesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/ingest-candidates',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ingest Elections
 *
 * Trigger manual ingestion of elections.
 * Provide election_ids to ingest specific elections, or states to discover and ingest upcoming elections.
 */
export const ingestElections = <ThrowOnError extends boolean = false>(options: Options<IngestElectionsData, ThrowOnError>): RequestResult<IngestElectionsResponses, IngestElectionsErrors, ThrowOnError> => (options.client ?? client).post<IngestElectionsResponses, IngestElectionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/ingest-elections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Ingest User Officials
 *
 * Trigger officials ingestion for a specific activist by their ID.
 * Looks up the activist's address and calls BallotReady + Congress.gov enrichment.
 */
export const ingestUserOfficials = <ThrowOnError extends boolean = false>(options: Options<IngestUserOfficialsData, ThrowOnError>): RequestResult<IngestUserOfficialsResponses, IngestUserOfficialsErrors, ThrowOnError> => (options.client ?? client).post<IngestUserOfficialsResponses, IngestUserOfficialsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/ingest-user-officials',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear Person Field Override
 *
 * Clear a manual override for a person field.
 * Field will resume auto-updates from daily ingestion.
 *
 * Allowed fields: full_name, biography, website_url, campaign_url
 */
export const clearPersonFieldOverride = <ThrowOnError extends boolean = false>(options: Options<ClearPersonFieldOverrideData, ThrowOnError>): RequestResult<ClearPersonFieldOverrideResponses, ClearPersonFieldOverrideErrors, ThrowOnError> => (options.client ?? client).delete<ClearPersonFieldOverrideResponses, ClearPersonFieldOverrideErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/officials/{person_id}/clear-override',
    ...options
});

/**
 * Get Person Overrides
 *
 * Get all field overrides for a person.
 * Shows which fields have manual overrides and their values.
 */
export const getPersonOverrides = <ThrowOnError extends boolean = false>(options: Options<GetPersonOverridesData, ThrowOnError>): RequestResult<GetPersonOverridesResponses, GetPersonOverridesErrors, ThrowOnError> => (options.client ?? client).get<GetPersonOverridesResponses, GetPersonOverridesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/officials/{person_id}/overrides',
    ...options
});

/**
 * Refresh Official
 *
 * Manually refresh a specific official's data from BallotReady and Congress.gov.
 *
 * This endpoint:
 * - Fetches fresh data from BallotReady using the person's ballot_ready_id
 * - Enriches with Congress.gov data if bioguide_id is available
 * - Updates the person record and their roles
 * - Preserves start_date and end_date from BallotReady (won't overwrite with Congress.gov)
 *
 * Use this when:
 * - An official's data needs to be updated immediately
 * - You want to fix incorrect role dates
 * - You need to refresh a single official without re-running full user ingestion
 */
export const refreshOfficial = <ThrowOnError extends boolean = false>(options: Options<RefreshOfficialData, ThrowOnError>): RequestResult<RefreshOfficialResponses, RefreshOfficialErrors, ThrowOnError> => (options.client ?? client).post<RefreshOfficialResponses, RefreshOfficialErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/officials/{person_id}/refresh',
    ...options
});

/**
 * Set Person Field Override
 *
 * Set a manual override for a person field.
 * Prevents daily auto-updates from changing this field.
 *
 * Allowed fields: full_name, biography, website_url, campaign_url
 *
 * Example request body:
 * {
 * "value": "Custom biography text here"
 * }
 */
export const setPersonFieldOverride = <ThrowOnError extends boolean = false>(options: Options<SetPersonFieldOverrideData, ThrowOnError>): RequestResult<SetPersonFieldOverrideResponses, SetPersonFieldOverrideErrors, ThrowOnError> => (options.client ?? client).post<SetPersonFieldOverrideResponses, SetPersonFieldOverrideErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/officials/{person_id}/set-override',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get All Recommendations
 *
 * Get all AI recommendations for review
 */
export const getAllRecommendations = <ThrowOnError extends boolean = false>(options?: Options<GetAllRecommendationsData, ThrowOnError>): RequestResult<GetAllRecommendationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAllRecommendationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/recommendations',
    ...options
});

/**
 * Get Pending Recommendations
 *
 * Get unpublished recommendations awaiting admin review
 */
export const getPendingRecommendations = <ThrowOnError extends boolean = false>(options?: Options<GetPendingRecommendationsData, ThrowOnError>): RequestResult<GetPendingRecommendationsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPendingRecommendationsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/recommendations/pending',
    ...options
});

/**
 * Update Recommendation
 *
 * Update/Edit an AI Recommendation
 */
export const updateRecommendation = <ThrowOnError extends boolean = false>(options: Options<UpdateRecommendationData, ThrowOnError>): RequestResult<UpdateRecommendationResponses, UpdateRecommendationErrors, ThrowOnError> => (options.client ?? client).put<UpdateRecommendationResponses, UpdateRecommendationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/recommendations/{rec_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get All Trending Topics
 *
 * Get all trending topics for review history, most recently fetched first.
 */
export const getAllTrendingTopics = <ThrowOnError extends boolean = false>(options?: Options<GetAllTrendingTopicsData, ThrowOnError>): RequestResult<GetAllTrendingTopicsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAllTrendingTopicsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/trending-topics',
    ...options
});

/**
 * Get Pending Trending Topics
 *
 * Get pending trending topics (with their candidate matches) awaiting admin review.
 */
export const getPendingTrendingTopics = <ThrowOnError extends boolean = false>(options?: Options<GetPendingTrendingTopicsData, ThrowOnError>): RequestResult<GetPendingTrendingTopicsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPendingTrendingTopicsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/trending-topics/pending',
    ...options
});

/**
 * Update Trending Topic
 *
 * Approve or reject a trending topic. Approving sets boost_expires_at
 * (TREND_BOOST_DURATION_DAYS from now) and auto-approves any candidate
 * match at/above AUTO_APPROVE_CONFIDENCE_THRESHOLD (currently: an exact
 * title/case_name hit) so review effort concentrates on the lower-confidence,
 * topic-only matches most likely to be wrong. Lower-confidence matches still
 * require individual review via PUT /trending-topics/{topic_id}/matches/{match_id}.
 */
export const updateTrendingTopic = <ThrowOnError extends boolean = false>(options: Options<UpdateTrendingTopicData, ThrowOnError>): RequestResult<UpdateTrendingTopicResponses, UpdateTrendingTopicErrors, ThrowOnError> => (options.client ?? client).put<UpdateTrendingTopicResponses, UpdateTrendingTopicErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/trending-topics/{topic_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Trending Topic Match
 *
 * Approve or reject an individual candidate match under a trending topic.
 * This is the actual mismatch-risk mitigation: a topic can have some
 * correct matches and some incorrect ones (e.g. a loose keyword hit on
 * an unrelated bill), so each match is gated independently.
 */
export const updateTrendingTopicMatch = <ThrowOnError extends boolean = false>(options: Options<UpdateTrendingTopicMatchData, ThrowOnError>): RequestResult<UpdateTrendingTopicMatchResponses, UpdateTrendingTopicMatchErrors, ThrowOnError> => (options.client ?? client).put<UpdateTrendingTopicMatchResponses, UpdateTrendingTopicMatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/admin/trending-topics/{topic_id}/matches/{match_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Ai Recommendations
 *
 * Fetch AI-generated recommendations based on user's survey profile.
 * Returns a paginated list of recommended entities with ideology-specific actions.
 *
 * These are proactively generated recommendations, not based on view history.
 *
 * Query params:
 * - page: Page number (default: 1)
 * - limit: Items per page (default: 10)
 * - entity_type: Optional filter (bill, regulation, court_case, ballot_measure)
 */
export const getAiRecommendations = <ThrowOnError extends boolean = false>(options?: Options<GetAiRecommendationsData, ThrowOnError>): RequestResult<GetAiRecommendationsResponses, GetAiRecommendationsErrors, ThrowOnError> => (options?.client ?? client).get<GetAiRecommendationsResponses, GetAiRecommendationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/ai-recommendations',
    ...options
});

/**
 * Get Access Token
 *
 * Get a new access token using a refresh token (Industry Standard Flow).
 *
 * This endpoint:
 * 1. Verifies the refresh token.
 * 2. Validates that the underlying session is still active in the database.
 * 3. Issues a NEW access token.
 * 4. Issues a NEW rotated refresh token.
 * 5. Updates the session's 'last_used_at' timestamp.
 */
export const getAccessToken = <ThrowOnError extends boolean = false>(options: Options<GetAccessTokenData, ThrowOnError>): RequestResult<GetAccessTokenResponses, GetAccessTokenErrors, ThrowOnError> => (options.client ?? client).post<GetAccessTokenResponses, GetAccessTokenErrors, ThrowOnError>({
    url: '/activist-arc/auth/access-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Account
 *
 * Permanently delete user account and data.
 * Requires password confirmation in the request body.
 * Manually cascades deletion in correct order to avoid foreign key constraint violations.
 */
export const deleteAccount = <ThrowOnError extends boolean = false>(options: Options<DeleteAccountData, ThrowOnError>): RequestResult<DeleteAccountResponses, DeleteAccountErrors, ThrowOnError> => (options.client ?? client).delete<DeleteAccountResponses, DeleteAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/auth/account',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Change Password
 *
 * Change password for logged-in user.
 */
export const changePassword = <ThrowOnError extends boolean = false>(options: Options<ChangePasswordData, ThrowOnError>): RequestResult<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError> => (options.client ?? client).post<ChangePasswordResponses, ChangePasswordErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/auth/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request password reset code
 *
 * Step 1 of password reset: Request a 4-digit reset code via email.
 */
export const forgotPassword = <ThrowOnError extends boolean = false>(options: Options<ForgotPasswordData, ThrowOnError>): RequestResult<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<ForgotPasswordResponses, ForgotPasswordErrors, ThrowOnError>({
    url: '/activist-arc/auth/forgot-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Login
 *
 * User login - Step 1: Verify credentials and send MFA code
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>): RequestResult<LoginResponses, LoginErrors, ThrowOnError> => (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: '/activist-arc/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get recent login activity
 *
 * Get recent login activity for the current user.
 *
 * Returns the last N login events (default 20), sorted newest first.
 * Unacknowledged entries represent alerts the user hasn't seen yet.
 */
export const getLoginActivity = <ThrowOnError extends boolean = false>(options?: Options<GetLoginActivityData, ThrowOnError>): RequestResult<GetLoginActivityResponses, GetLoginActivityErrors, ThrowOnError> => (options?.client ?? client).get<GetLoginActivityResponses, GetLoginActivityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/auth/login-activity',
    ...options
});

/**
 * Acknowledge login activity records
 *
 * Mark login activity records as acknowledged (seen).
 *
 * If `activity_ids` is provided, only those records are acknowledged.
 * If omitted, all unacknowledged records for the user are acknowledged.
 */
export const acknowledgeLoginActivity = <ThrowOnError extends boolean = false>(options: Options<AcknowledgeLoginActivityData, ThrowOnError>): RequestResult<AcknowledgeLoginActivityResponses, AcknowledgeLoginActivityErrors, ThrowOnError> => (options.client ?? client).post<AcknowledgeLoginActivityResponses, AcknowledgeLoginActivityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/auth/login-activity/acknowledge',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Logout
 *
 * Logout user — removes the current session from session_tokens
 * and removes the device's FCM token from fcm_device_tokens if provided.
 */
export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>): RequestResult<LogoutResponses, LogoutErrors, ThrowOnError> => (options?.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/auth/logout',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options?.headers
    }
});

/**
 * Resend Mfa Code
 *
 * Resend MFA verification code
 *
 * - **activist_id**: User ID from login response
 *
 * Generates a new MFA code and sends it to the user's email.
 * The previous code will be invalidated.
 */
export const resendMfaCode = <ThrowOnError extends boolean = false>(options: Options<ResendMfaCodeData, ThrowOnError>): RequestResult<ResendMfaCodeResponses, ResendMfaCodeErrors, ThrowOnError> => (options.client ?? client).post<ResendMfaCodeResponses, ResendMfaCodeErrors, ThrowOnError>({
    url: '/activist-arc/auth/mfa-resend',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mfa Verify
 *
 * MFA Verification - Step 2: Verify MFA code and get access token
 *
 * Now includes progress flags to help UI navigate to the correct onboarding step.
 * Also creates a session record and logs login activity.
 */
export const mfaVerify = <ThrowOnError extends boolean = false>(options: Options<MfaVerifyData, ThrowOnError>): RequestResult<MfaVerifyResponses, MfaVerifyErrors, ThrowOnError> => (options.client ?? client).post<MfaVerifyResponses, MfaVerifyErrors, ThrowOnError>({
    url: '/activist-arc/auth/mfa-verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset password using code
 *
 * Step 2 of password reset: Verify the 4-digit code and set a new password.
 *
 * Security: This action will revoke ALL active sessions and FCM tokens.
 */
export const resetPassword = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordData, ThrowOnError>): RequestResult<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<ResetPasswordResponses, ResetPasswordErrors, ThrowOnError>({
    url: '/activist-arc/auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send Mfa Code
 *
 * Send MFA verification code via Email or SMS.
 *
 * - **activist_id**: User ID from login response
 * - **method**: "email" or "sms" (defaults to email)
 *
 * Generates a new MFA code and sends it via the requested method.
 * The previous code will be invalidated.
 */
export const sendMfaCode = <ThrowOnError extends boolean = false>(options: Options<SendMfaCodeData, ThrowOnError>): RequestResult<SendMfaCodeResponses, SendMfaCodeErrors, ThrowOnError> => (options.client ?? client).post<SendMfaCodeResponses, SendMfaCodeErrors, ThrowOnError>({
    url: '/activist-arc/auth/send-mfa-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke all sessions (log out everywhere)
 *
 * Revoke all active sessions for the user, logging them out of everywhere including the current device.
 */
export const revokeAllSessions = <ThrowOnError extends boolean = false>(options?: Options<RevokeAllSessionsData, ThrowOnError>): RequestResult<RevokeAllSessionsResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<RevokeAllSessionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/auth/sessions',
    ...options
});

/**
 * List active sessions
 *
 * Get all active sessions for the current user.
 *
 * Each session includes device info, approximate location, IP address,
 * and timestamps. The calling session is marked with `is_current: true`.
 */
export const getSessions = <ThrowOnError extends boolean = false>(options?: Options<GetSessionsData, ThrowOnError>): RequestResult<GetSessionsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSessionsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/auth/sessions',
    ...options
});

/**
 * Revoke a specific session
 *
 * Revoke (log out) a specific session by session_id.
 *
 * The `session_id` can be found in the GET /auth/sessions response.
 * You cannot revoke the current session via this endpoint — use POST /auth/logout instead.
 */
export const revokeSession = <ThrowOnError extends boolean = false>(options: Options<RevokeSessionData, ThrowOnError>): RequestResult<RevokeSessionResponses, RevokeSessionErrors, ThrowOnError> => (options.client ?? client).delete<RevokeSessionResponses, RevokeSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/auth/sessions/{session_id}',
    ...options
});

/**
 * Sign Up
 *
 * Step 1: Account Creation (Email & Password)
 *
 * Creates a new user account with just email and password.
 * Returns activist_id for subsequent steps.
 */
export const signUp = <ThrowOnError extends boolean = false>(options: Options<SignUpData, ThrowOnError>): RequestResult<SignUpResponses, SignUpErrors, ThrowOnError> => (options.client ?? client).post<SignUpResponses, SignUpErrors, ThrowOnError>({
    url: '/activist-arc/auth/sign-up',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Signup Step2
 *
 * Signup Step: Address and Residency Information
 */
export const signupStep2 = <ThrowOnError extends boolean = false>(options: Options<SignupStep2Data, ThrowOnError>): RequestResult<SignupStep2Responses, SignupStep2Errors, ThrowOnError> => (options.client ?? client).put<SignupStep2Responses, SignupStep2Errors, ThrowOnError>({
    url: '/activist-arc/auth/sign-up/address-details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Signup Basic Details
 *
 * Signup Step: Basic Details (Name, Phone, DOB, etc.)
 *
 * Updates the user profile with personal details.
 * This step comes after MFA/Persona in the new flow.
 * Uses activist_id to identify user (auth token optional/not required per spec).
 */
export const signupBasicDetails = <ThrowOnError extends boolean = false>(options: Options<SignupBasicDetailsData, ThrowOnError>): RequestResult<SignupBasicDetailsResponses, SignupBasicDetailsErrors, ThrowOnError> => (options.client ?? client).post<SignupBasicDetailsResponses, SignupBasicDetailsErrors, ThrowOnError>({
    url: '/activist-arc/auth/sign-up/basic-details',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Upload Signup Government Id
 *
 * Signup Step: Upload Government ID
 *
 * This endpoint allows uploading a government ID during the sign-up flow without being logged in.
 * It identifies the user by the activist_id returned from the sign-up step 1.
 *
 * - **activist_id**: ID returned from Step 1
 * - **file**: Image file (JPEG, PNG, WebP)
 *
 * The image is stored under arc-folder/{user_id}/government-ids/ in S3.
 */
export const uploadSignupGovernmentId = <ThrowOnError extends boolean = false>(options: Options<UploadSignupGovernmentIdData, ThrowOnError>): RequestResult<UploadSignupGovernmentIdResponses, UploadSignupGovernmentIdErrors, ThrowOnError> => (options.client ?? client).post<UploadSignupGovernmentIdResponses, UploadSignupGovernmentIdErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/activist-arc/auth/sign-up/government-id',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Signup Preview Update
 *
 * Signup Step 4: Update Details Before Confirmation
 *
 * Performance optimizations:
 * - Synchronous execution (no async overhead for I/O-bound operations)
 * - Removed db.refresh() - not needed since we have the object in memory
 * - S3 call with error handling (non-blocking)
 * - Efficient field updates with bulk assignment
 */
export const signupPreviewUpdate = <ThrowOnError extends boolean = false>(options: Options<SignupPreviewUpdateData, ThrowOnError>): RequestResult<SignupPreviewUpdateResponses, SignupPreviewUpdateErrors, ThrowOnError> => (options.client ?? client).put<SignupPreviewUpdateResponses, SignupPreviewUpdateErrors, ThrowOnError>({
    url: '/activist-arc/auth/sign-up/preview',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Signup Preview
 *
 * Signup Step 4: Preview/Confirm Details
 */
export const signupPreview = <ThrowOnError extends boolean = false>(options: Options<SignupPreviewData, ThrowOnError>): RequestResult<SignupPreviewResponses, SignupPreviewErrors, ThrowOnError> => (options.client ?? client).get<SignupPreviewResponses, SignupPreviewErrors, ThrowOnError>({ url: '/activist-arc/auth/sign-up/preview/{activist_id}', ...options });

/**
 * Upload Signup Profile Picture
 *
 * Signup Step: Upload Profile Picture
 */
export const uploadSignupProfilePicture = <ThrowOnError extends boolean = false>(options: Options<UploadSignupProfilePictureData, ThrowOnError>): RequestResult<UploadSignupProfilePictureResponses, UploadSignupProfilePictureErrors, ThrowOnError> => (options.client ?? client).post<UploadSignupProfilePictureResponses, UploadSignupProfilePictureErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/activist-arc/auth/sign-up/profile-picture',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Upload Signup Selfie
 *
 * Signup Step: Upload Selfie for Photo Verification
 *
 * This endpoint allows uploading a selfie during the sign-up flow without being logged in.
 * It identifies the user by the activist_id returned from the sign-up step 1.
 *
 * - **activist_id**: ID returned from Step 1
 * - **file**: Image file (JPEG, PNG, WebP)
 *
 * The image is stored under arc-folder/{user_id}/selfies/ in S3.
 */
export const uploadSignupSelfie = <ThrowOnError extends boolean = false>(options: Options<UploadSignupSelfieData, ThrowOnError>): RequestResult<UploadSignupSelfieResponses, UploadSignupSelfieErrors, ThrowOnError> => (options.client ?? client).post<UploadSignupSelfieResponses, UploadSignupSelfieErrors, ThrowOnError>({
    ...formDataBodySerializer,
    url: '/activist-arc/auth/sign-up/selfie',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Voter Link
 *
 * Signup Step: LINK the matched voter record to the account.
 *
 * Re-runs the lookup (served from the 1h payload cache, so this is fast) to
 * re-verify the match server-side — it never trusts a client-supplied voter id —
 * then persists the link, districts, party, vote history, and PAV status.
 */
export const voterLink = <ThrowOnError extends boolean = false>(options: Options<VoterLinkData, ThrowOnError>): RequestResult<VoterLinkResponses, VoterLinkErrors, ThrowOnError> => (options.client ?? client).post<VoterLinkResponses, VoterLinkErrors, ThrowOnError>({
    url: '/activist-arc/auth/sign-up/voter-link',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Voter Lookup
 *
 * Signup Step: Voter Registration LOOKUP (read-only).
 *
 * Returns the matched voter record but does NOT link it to the account. Results
 * are cached for 1 hour keyed by the lookup payload; pass `?refresh=true` to
 * bypass the cache and force a fresh lookup. To actually link the matched record,
 * call POST /sign-up/voter-link.
 */
export const voterLookup = <ThrowOnError extends boolean = false>(options: Options<VoterLookupData, ThrowOnError>): RequestResult<VoterLookupResponses, VoterLookupErrors, ThrowOnError> => (options.client ?? client).post<VoterLookupResponses, VoterLookupErrors, ThrowOnError>({
    url: '/activist-arc/auth/sign-up/voter-lookup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Update Government Id
 *
 * Update your government ID (requires authentication)
 *
 * **Authentication Required:** Bearer token in Authorization header
 *
 * - **file**: Image file (JPEG, PNG, WebP)
 *
 * The image is stored under arc-folder/{user_id}/government-ids/ in S3.
 */
export const updateGovernmentId = <ThrowOnError extends boolean = false>(options: Options<UpdateGovernmentIdData, ThrowOnError>): RequestResult<UpdateGovernmentIdResponses, UpdateGovernmentIdErrors, ThrowOnError> => (options.client ?? client).put<UpdateGovernmentIdResponses, UpdateGovernmentIdErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/auth/update-government-id',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Update Profile Picture
 *
 * Update your profile picture (requires authentication)
 *
 * **Authentication Required:** Bearer token in Authorization header
 *
 * - **file**: Image file (JPEG, PNG, WebP)
 *
 * This endpoint:
 * 1. Validates JWT token to identify the user
 * 2. Validates file type and size
 * 3. Uploads to S3 with presigned URL
 * 4. Updates user's profile_picture_url in database with S3 key
 * 5. Returns both presigned URL (for immediate use) and S3 key (stored in DB)
 *
 * **How to authenticate:**
 * 1. Login and complete MFA to get access_token
 * 2. Click "Authorize" button (🔒) at the top of Swagger UI
 * 3. Enter: Bearer <your_access_token>
 * 4. Click "Authorize" and "Close"
 * 5. Now you can use this endpoint
 *
 * **Note:** The user is automatically identified from the JWT token, so you don't need to specify activist_id.
 */
export const updateProfilePicture = <ThrowOnError extends boolean = false>(options: Options<UpdateProfilePictureData, ThrowOnError>): RequestResult<UpdateProfilePictureResponses, UpdateProfilePictureErrors, ThrowOnError> => (options.client ?? client).put<UpdateProfilePictureResponses, UpdateProfilePictureErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/auth/update-profile-picture',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Update Selfie
 *
 * Update your selfie for photo verification (requires authentication)
 *
 * **Authentication Required:** Bearer token in Authorization header
 *
 * - **file**: Image file (JPEG, PNG, WebP)
 *
 * The image is stored under arc-folder/{user_id}/selfies/ in S3.
 */
export const updateSelfie = <ThrowOnError extends boolean = false>(options: Options<UpdateSelfieData, ThrowOnError>): RequestResult<UpdateSelfieResponses, UpdateSelfieErrors, ThrowOnError> => (options.client ?? client).put<UpdateSelfieResponses, UpdateSelfieErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/auth/update-selfie',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Get Candidates
 *
 * Get candidates for the user's next upcoming election, grouped by race/position.
 */
export const getCandidates = <ThrowOnError extends boolean = false>(options?: Options<GetCandidatesData, ThrowOnError>): RequestResult<GetCandidatesResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCandidatesResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/candidates',
    ...options
});

/**
 * List all config flags
 */
export const listConfigs = <ThrowOnError extends boolean = false>(options?: Options<ListConfigsData, ThrowOnError>): RequestResult<ListConfigsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<ListConfigsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/config',
    ...options
});

/**
 * Create a new config flag
 */
export const createConfig = <ThrowOnError extends boolean = false>(options: Options<CreateConfigData, ThrowOnError>): RequestResult<CreateConfigResponses, CreateConfigErrors, ThrowOnError> => (options.client ?? client).post<CreateConfigResponses, CreateConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a config flag
 */
export const deleteConfig = <ThrowOnError extends boolean = false>(options: Options<DeleteConfigData, ThrowOnError>): RequestResult<DeleteConfigResponses, DeleteConfigErrors, ThrowOnError> => (options.client ?? client).delete<DeleteConfigResponses, DeleteConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/config/{key}',
    ...options
});

/**
 * Get a single config flag by key
 */
export const getConfig = <ThrowOnError extends boolean = false>(options: Options<GetConfigData, ThrowOnError>): RequestResult<GetConfigResponses, GetConfigErrors, ThrowOnError> => (options.client ?? client).get<GetConfigResponses, GetConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/config/{key}',
    ...options
});

/**
 * Update the value of an existing config flag
 */
export const updateConfig = <ThrowOnError extends boolean = false>(options: Options<UpdateConfigData, ThrowOnError>): RequestResult<UpdateConfigResponses, UpdateConfigErrors, ThrowOnError> => (options.client ?? client).patch<UpdateConfigResponses, UpdateConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/config/{key}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Dashboard
 *
 * Get aggregated dashboard data for the current user.
 *
 * Returns:
 * - User Profile: Name, photo, age, gender, address, party, voter registration status
 * - Next Election: The single nearest upcoming election with countdown
 * - Voting Method: User's preferred voting method
 * - Officials: List of elected officials (Federal, State, Local)
 */
export const getDashboard = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardData, ThrowOnError>): RequestResult<GetDashboardResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetDashboardResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/dashboard',
    ...options
});

/**
 * Get Elected Officials
 *
 * Fetch elected officials (Paginated).
 * New Architecture: ONE-TIME INGESTION + DB READ.
 *
 * This endpoint now queries the `activist_official_relations` table
 * to find officials linked to the current user. All data (Federal, State, Local)
 * is served from our DB.
 */
export const getElectedOfficials = <ThrowOnError extends boolean = false>(options?: Options<GetElectedOfficialsData, ThrowOnError>): RequestResult<GetElectedOfficialsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetElectedOfficialsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/elected-officials',
    ...options
});

/**
 * Get Federal Officials
 *
 * Fetch Federal elected officials from DB via ActivistOfficialConnection.
 */
export const getFederalOfficials = <ThrowOnError extends boolean = false>(options?: Options<GetFederalOfficialsData, ThrowOnError>): RequestResult<GetFederalOfficialsResponses, GetFederalOfficialsErrors, ThrowOnError> => (options?.client ?? client).get<GetFederalOfficialsResponses, GetFederalOfficialsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/elected-officials/federal',
    ...options
});

/**
 * Get Local Officials
 *
 * Fetch Local/County elected officials from DB via ActivistOfficialConnection.
 * Results originally ingested from BallotReady (County/Local).
 */
export const getLocalOfficials = <ThrowOnError extends boolean = false>(options?: Options<GetLocalOfficialsData, ThrowOnError>): RequestResult<GetLocalOfficialsResponses, GetLocalOfficialsErrors, ThrowOnError> => (options?.client ?? client).get<GetLocalOfficialsResponses, GetLocalOfficialsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/elected-officials/local',
    ...options
});

/**
 * Get State Officials
 *
 * Fetch State elected officials from DB via ActivistOfficialConnection.
 */
export const getStateOfficials = <ThrowOnError extends boolean = false>(options?: Options<GetStateOfficialsData, ThrowOnError>): RequestResult<GetStateOfficialsResponses, GetStateOfficialsErrors, ThrowOnError> => (options?.client ?? client).get<GetStateOfficialsResponses, GetStateOfficialsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/elected-officials/state',
    ...options
});

/**
 * Get Election Details
 *
 * Get enriched details for the user's next upcoming election.
 * Includes deadlines, polling locations with voting method support,
 * and data availability flags.
 */
export const getElectionDetails = <ThrowOnError extends boolean = false>(options?: Options<GetElectionDetailsData, ThrowOnError>): RequestResult<GetElectionDetailsResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetElectionDetailsResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/election-details',
    ...options
});

/**
 * Get Upcoming Elections
 *
 * Fetch upcoming elections (Paginated).
 */
export const getUpcomingElections = <ThrowOnError extends boolean = false>(options?: Options<GetUpcomingElectionsData, ThrowOnError>): RequestResult<GetUpcomingElectionsResponses, GetUpcomingElectionsErrors, ThrowOnError> => (options?.client ?? client).get<GetUpcomingElectionsResponses, GetUpcomingElectionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/elections',
    ...options
});

/**
 * Batch Process Entities
 *
 * Process multiple entities in a batch job.
 *
 * **Query Options:**
 * - Filter by entity_types: ['bill', 'regulation', 'court_decision', 'ballot_measure', 'executive_order']
 * - Filter by ai_classified: false (only unclassified) or true (only classified)
 * - Limit: Max entities to process (default: 250, max: 500)
 * - Explicit entity_ids: Process specific entities
 *
 * **Cost Control:**
 * - Set cost_limit_usd to enforce maximum spend
 * - Batch stops automatically if limit reached
 * - Use dry_run=true to estimate cost without processing
 *
 * **Async Execution:**
 * - Real runs are processed in the background: the response returns immediately
 * with status `queued` (no more ALB timeouts on large batches)
 * - Use returned batch_id to check progress via GET /entities/recommend/batch/{batch_id}/status
 * - dry_run requests are answered synchronously (no LLM calls involved)
 *
 * **Example:**
 * ```json
 * {
 * "query": {
 * "entity_types": ["bill", "regulation"],
 * "ai_classified": false,
 * "limit": 100
 * },
 * "cost_limit_usd": 1.0,
 * "dry_run": false
 * }
 * ```
 */
export const processBatch = <ThrowOnError extends boolean = false>(options: Options<ProcessBatchData, ThrowOnError>): RequestResult<ProcessBatchResponses, ProcessBatchErrors, ThrowOnError> => (options.client ?? client).post<ProcessBatchResponses, ProcessBatchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/entities/recommend/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Batch Status
 *
 * Get status of a batch processing job.
 *
 * **Status Values:**
 * - `queued`: Job created, not started yet
 * - `running`: Currently processing entities
 * - `completed`: All entities processed (or cost limit reached)
 * - `failed`: Job encountered fatal error
 *
 * **Metrics:**
 * - processed_count: Number successfully processed
 * - failed_count: Number that failed
 * - actual_cost_usd: Total cost incurred
 * - errors: List of errors (if any)
 */
export const getBatchStatus = <ThrowOnError extends boolean = false>(options: Options<GetBatchStatusData, ThrowOnError>): RequestResult<GetBatchStatusResponses, GetBatchStatusErrors, ThrowOnError> => (options.client ?? client).get<GetBatchStatusResponses, GetBatchStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/entities/recommend/batch/{batch_id}/status',
    ...options
});

/**
 * Get Personalized Recommendation
 *
 * Get a personalized action recommendation for a specific entity.
 *
 * **What it returns:**
 * - **1 ideology-specific bucket action** tailored to your political orientation (from Survey Q5)
 * - If you haven't completed the survey, defaults to 'center' bucket
 * - Includes talking points, framing, and recommended action type
 *
 * **Behavior:**
 * - If entity is already classified: Returns cached result immediately (fast!)
 * - If not yet classified: Processes entity and generates recommendations (~2-3 seconds)
 * - If entity is being processed by another request: Returns status='processing'
 *
 * **Geographical Filtering:**
 * - You can only process entities relevant to your location
 * - Federal entities: Available to all users
 * - State entities: Only available if it's YOUR state
 * - Example: CA users cannot process NY state bills
 *
 * **Usage:**
 * ```
 * POST /activist-arc/entities/{entity_id}/recommend?entity_type=bill
 * ```
 *
 * **Cost:**
 * - Cached results: Free (instant)
 * - New processing: ~$0.0025 per entity
 */
export const processSingleEntity = <ThrowOnError extends boolean = false>(options: Options<ProcessSingleEntityData, ThrowOnError>): RequestResult<ProcessSingleEntityResponses, ProcessSingleEntityErrors, ThrowOnError> => (options.client ?? client).post<ProcessSingleEntityResponses, ProcessSingleEntityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/entities/{entity_id}/recommend',
    ...options
});

/**
 * Generate Feed For User
 *
 * Generate or regenerate feed cache for a specific user.
 *
 * Generates 1000 feed items with 3-tier prioritization:
 * - Tier 1: Tracked items with updates (salience 100, pinned)
 * - Tier 2: Ranked topics with calculated salience (0-10)
 * - Tier 3: Unranked topics sorted by date (salience 0)
 *
 * Args:
 * activist_id: User ID to generate feed for. If not provided, generates for current user.
 * force: If True, clears existing cache and regenerates. If False, only generates if cache is empty/expired.
 *
 * Returns:
 * Generation result with status, total items, and tier breakdown.
 *
 * Use Cases:
 * - Post-survey: Call immediately after survey completion to pre-generate feed
 * - Profile update: Call with force=true when user updates their preferences
 * - Admin support: Generate feeds for specific users for troubleshooting
 */
export const generateFeedForUser = <ThrowOnError extends boolean = false>(options?: Options<GenerateFeedForUserData, ThrowOnError>): RequestResult<GenerateFeedForUserResponses, GenerateFeedForUserErrors, ThrowOnError> => (options?.client ?? client).post<GenerateFeedForUserResponses, GenerateFeedForUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/feed/generate',
    ...options
});

/**
 * Get Feed Item Detail
 *
 * Get detailed information for a specific feed item.
 *
 * Args:
 * item_id: UUID of the item to fetch details for
 * item_type: Type of the item (committee, bill, executive_order, law, elected_official, court_case, regulation)
 *
 * Returns:
 * Complete details for the specified item in its type-specific structure.
 */
export const getFeedItemDetail = <ThrowOnError extends boolean = false>(options: Options<GetFeedItemDetailData, ThrowOnError>): RequestResult<GetFeedItemDetailResponses, GetFeedItemDetailErrors, ThrowOnError> => (options.client ?? client).get<GetFeedItemDetailResponses, GetFeedItemDetailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/feed/item/{item_id}',
    ...options
});

/**
 * Get Main Feed
 *
 * Get Main Feed for User with page-based pagination and filtering.
 *
 * Returns pre-generated feed items from cache with 3-tier prioritization:
 * - Tier 1: Tracked items with updates (salience 100, pinned)
 * - Tier 2: Ranked topics with calculated salience (0-10)
 * - Tier 3: Unranked topics sorted by date (salience 0)
 *
 * Args:
 * filter: Filter type - ALL (all recommendations), FAVORITES (only favorited items),
 * FOLLOWING (only followed entities), RECOMMENDED (same as ALL)
 * page: Page number (starting from 1, default 1)
 * limit: Number of items to return per page (1-100, default 50)
 *
 * Returns:
 * {
 * "items": [...hydrated feed items...],
 * "pagination": {
 * "page": 1,
 * "limit": 50,
 * "has_more": true/false
 * }
 * }
 */
export const getMainFeed = <ThrowOnError extends boolean = false>(options?: Options<GetMainFeedData, ThrowOnError>): RequestResult<GetMainFeedResponses, GetMainFeedErrors, ThrowOnError> => (options?.client ?? client).get<GetMainFeedResponses, GetMainFeedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/feed/main',
    ...options
});

/**
 * Trigger Dry Run Sync
 *
 * Internal Endpoint (admin-only): Trigger a 'Dry Run' to refresh data for users.
 * Iterates through users with addresses and creates new snapshots.
 */
export const triggerDryRunSync = <ThrowOnError extends boolean = false>(options?: Options<TriggerDryRunSyncData, ThrowOnError>): RequestResult<TriggerDryRunSyncResponses, TriggerDryRunSyncErrors, ThrowOnError> => (options?.client ?? client).post<TriggerDryRunSyncResponses, TriggerDryRunSyncErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/internal/dry-run-sync',
    ...options
});

/**
 * Get My Recommendations
 *
 * Fetch all recommended actions the user has viewed/generated.
 * Returns a paginated list of entities with their ideology-specific recommendation.
 *
 * Query params:
 * - page: Page number (default: 1)
 * - limit: Items per page (default: 10)
 * - entity_type: Optional filter (bill, regulation, court_case, ballot_measure)
 */
export const getMyRecommendations = <ThrowOnError extends boolean = false>(options?: Options<GetMyRecommendationsData, ThrowOnError>): RequestResult<GetMyRecommendationsResponses, GetMyRecommendationsErrors, ThrowOnError> => (options?.client ?? client).get<GetMyRecommendationsResponses, GetMyRecommendationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/my-recommendations',
    ...options
});

/**
 * List organization accounts (Activist staff only)
 *
 * List organization accounts, newest first unless ordered otherwise.
 *
 * Deactivated organizations are hidden unless include_deleted is true.
 *
 * Only the columns named by `sort` can be ordered by. Anything else is
 * refused, listing what is allowed, rather than being answered in the default
 * order - which would look as though the ordering had been applied.
 *
 * The ordering is applied to everything that matched before the page is taken,
 * and the identifier settles ties, so paging never returns a row twice or
 * skips one.
 */
export const listOrganizations = <ThrowOnError extends boolean = false>(options?: Options<ListOrganizationsData, ThrowOnError>): RequestResult<ListOrganizationsResponses, ListOrganizationsErrors, ThrowOnError> => (options?.client ?? client).get<ListOrganizationsResponses, ListOrganizationsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts',
    ...options
});

/**
 * Create an organization account (Activist staff only)
 *
 * Create an organization account.
 *
 * Only the name is required; everything else can be filled in later with
 * PATCH. New accounts start as PENDING — creating an account is a separate act
 * from activating it.
 */
export const createOrganization = <ThrowOnError extends boolean = false>(options: Options<CreateOrganizationData, ThrowOnError>): RequestResult<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError> => (options.client ?? client).post<CreateOrganizationResponses, CreateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * The audit log across every organization (Activist staff only)
 *
 * Every recorded action, newest first, one page at a time, each naming its
 * organization. Every filter set must match. A `to` date before the `from`
 * date is refused.
 */
export const staffActivity = <ThrowOnError extends boolean = false>(options?: Options<StaffActivityData, ThrowOnError>): RequestResult<StaffActivityResponses, StaffActivityErrors, ThrowOnError> => (options?.client ?? client).get<StaffActivityResponses, StaffActivityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts/activity',
    ...options
});

/**
 * Everybody in the platform-wide audit log (Activist staff only)
 *
 * Each person with an entry in the feed, once, with the name they had most
 * recently. People since removed are included, because their entries are.
 */
export const staffActivityActors = <ThrowOnError extends boolean = false>(options?: Options<StaffActivityActorsData, ThrowOnError>): RequestResult<StaffActivityActorsResponses, StaffActivityActorsErrors, ThrowOnError> => (options?.client ?? client).get<StaffActivityActorsResponses, StaffActivityActorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts/activity/actors',
    ...options
});

/**
 * Deactivate an organization account (Activist staff only)
 *
 * Deactivate an organization account.
 *
 * This is a soft delete. Nothing is removed from the database: the status
 * becomes DEACTIVATED and the deactivation time is recorded, so supporter and
 * member relationships are kept. Reactivate with PATCH {"status": "ACTIVE"}.
 *
 * Calling this on an already-deactivated organization succeeds and changes
 * nothing, so a repeated request does not look like a failure.
 *
 * The reason travels in the body rather than in the address. It is free-text
 * staff commentary about why a customer relationship ended, and a query
 * parameter would put it into web server access logs, proxy logs and browser
 * history.
 */
export const deleteOrganization = <ThrowOnError extends boolean = false>(options: Options<DeleteOrganizationData, ThrowOnError>): RequestResult<DeleteOrganizationResponses, DeleteOrganizationErrors, ThrowOnError> => (options.client ?? client).delete<DeleteOrganizationResponses, DeleteOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts/{organization_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get one organization account (Activist staff only)
 *
 * Get the full record for one organization, including billing and contract
 * detail. Deactivated organizations are returned too, so staff can inspect and
 * reactivate them.
 */
export const getOrganization = <ThrowOnError extends boolean = false>(options: Options<GetOrganizationData, ThrowOnError>): RequestResult<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError> => (options.client ?? client).get<GetOrganizationResponses, GetOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts/{organization_id}',
    ...options
});

/**
 * Update an organization account (Activist staff only)
 *
 * Update part of an organization account.
 *
 * Only the fields you send are changed. A field you leave out keeps its
 * current value; a field you send as null is cleared. Sending a field name
 * that does not exist is rejected rather than silently ignored.
 *
 * The contact objects are the exception: primary_contact, public_contact and
 * billing_contact are replaced whole, not merged. Send the complete contact
 * every time, or the parts you leave out will be lost.
 *
 * Setting the status to ACTIVE reactivates a deactivated organization.
 * Changing the slug breaks any existing link that used the old one.
 */
export const updateOrganization = <ThrowOnError extends boolean = false>(options: Options<UpdateOrganizationData, ThrowOnError>): RequestResult<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError> => (options.client ?? client).patch<UpdateOrganizationResponses, UpdateOrganizationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts/{organization_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * One organization's audit log (Activist staff only)
 *
 * The same feed, fixed to one organization. An unknown one is a 404.
 */
export const staffOrganizationActivity = <ThrowOnError extends boolean = false>(options: Options<StaffOrganizationActivityData, ThrowOnError>): RequestResult<StaffOrganizationActivityResponses, StaffOrganizationActivityErrors, ThrowOnError> => (options.client ?? client).get<StaffOrganizationActivityResponses, StaffOrganizationActivityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts/{organization_id}/activity',
    ...options
});

/**
 * Everybody in one organization's audit log (Activist staff only)
 *
 * The actors list for one organization's feed. An unknown one is a 404.
 */
export const staffOrganizationActivityActors = <ThrowOnError extends boolean = false>(options: Options<StaffOrganizationActivityActorsData, ThrowOnError>): RequestResult<StaffOrganizationActivityActorsResponses, StaffOrganizationActivityActorsErrors, ThrowOnError> => (options.client ?? client).get<StaffOrganizationActivityActorsResponses, StaffOrganizationActivityActorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts/{organization_id}/activity/actors',
    ...options
});

/**
 * Invite an organization's Super Admin (Activist staff only)
 *
 * Create an invited Super Admin account and email a link that sets its
 * password.
 *
 * The role is always SUPER_ADMIN. A role in the body is ignored rather than
 * honoured, so this route cannot be used to fill an organization with Admins
 * who have nobody to administer them.
 *
 * If the address already has a portal account with another organization, they
 * are added to this one on the account they already have - one person, two
 * organizations, one password. Two things are still refused as a conflict: an
 * Activist Technologies address, because staff do not join customers; and
 * somebody who is already a member here.
 *
 * If the email cannot be sent the invitation still exists and the reply says
 * so. Resend it rather than inviting the person again, which would leave two
 * live links.
 */
export const inviteOrganizationSuperAdmin = <ThrowOnError extends boolean = false>(options: Options<InviteOrganizationSuperAdminData, ThrowOnError>): RequestResult<InviteOrganizationSuperAdminResponses, InviteOrganizationSuperAdminErrors, ThrowOnError> => (options.client ?? client).post<InviteOrganizationSuperAdminResponses, InviteOrganizationSuperAdminErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts/{organization_id}/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke an invitation (Activist staff only)
 *
 * Call an invitation off.
 *
 * The link stops working and the membership is marked revoked, which releases
 * the address so the same person can be invited again. Their account survives
 * if they belong to another organization, and is closed if this was their
 * only one.
 *
 * Revoking an invitation that is already revoked succeeds and changes nothing,
 * so a repeated request does not look like a failure.
 */
export const revokeOrganizationInvitation = <ThrowOnError extends boolean = false>(options: Options<RevokeOrganizationInvitationData, ThrowOnError>): RequestResult<RevokeOrganizationInvitationResponses, RevokeOrganizationInvitationErrors, ThrowOnError> => (options.client ?? client).delete<RevokeOrganizationInvitationResponses, RevokeOrganizationInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts/{organization_id}/invitations/{invitation_id}',
    ...options
});

/**
 * Send a fresh invitation link (Activist staff only)
 *
 * Issue a new link and stop the previous one working.
 *
 * The person's place in the organization stays invited throughout; only the
 * link changes.
 */
export const resendOrganizationInvitation = <ThrowOnError extends boolean = false>(options: Options<ResendOrganizationInvitationData, ThrowOnError>): RequestResult<ResendOrganizationInvitationResponses, ResendOrganizationInvitationErrors, ThrowOnError> => (options.client ?? client).post<ResendOrganizationInvitationResponses, ResendOrganizationInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts/{organization_id}/invitations/{invitation_id}/resend',
    ...options
});

/**
 * One organization's notification allowance this month (Activist staff only)
 *
 * Limit, used and remaining for this organization this month - the same
 * object the detail read nests as notification_allowance, on its own for a
 * screen that wants to poll it without re-reading the whole record.
 *
 * The month is the UTC calendar month. `used` is sent plus scheduled;
 * `remaining` never goes below zero. Deactivated organizations are served
 * too, as the detail read serves them.
 */
export const readOrganizationNotificationAllowance = <ThrowOnError extends boolean = false>(options: Options<ReadOrganizationNotificationAllowanceData, ThrowOnError>): RequestResult<ReadOrganizationNotificationAllowanceResponses, ReadOrganizationNotificationAllowanceErrors, ThrowOnError> => (options.client ?? client).get<ReadOrganizationNotificationAllowanceResponses, ReadOrganizationNotificationAllowanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts/{organization_id}/notification-allowance',
    ...options
});

/**
 * An organization's portal users and invitations (Activist staff only)
 *
 * Who this organization's portal users are, and where each of them is.
 *
 * Users and invitations are one list because they are one record. Each row
 * carries the role held in THIS organization; somebody who also belongs to
 * another appears once, and the other one is not named.
 *
 * Revoked and removed people are included and marked as past, so it is clear
 * why an address cannot be invited again.
 *
 * No Activist Technologies account appears here: staff hold no memberships,
 * so there is nothing for the query to find.
 */
export const listOrganizationPortalUsers = <ThrowOnError extends boolean = false>(options: Options<ListOrganizationPortalUsersData, ThrowOnError>): RequestResult<ListOrganizationPortalUsersResponses, ListOrganizationPortalUsersErrors, ThrowOnError> => (options.client ?? client).get<ListOrganizationPortalUsersResponses, ListOrganizationPortalUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/accounts/{organization_id}/users',
    ...options
});

/**
 * Ask for a code to set a new password
 *
 * Email a code that can be used to set a new password.
 *
 * The reply is identical whether the address has an account, has none, or has
 * one that cannot sign in, and it carries no identifier. There is a single
 * exit below for that reason: an early return for the unknown case is the
 * obvious way to reintroduce the leak.
 *
 * An account that is not ACTIVE is not sent a code, so an invitation cannot be
 * skipped and a suspension cannot be worked around here. The person is not
 * told that, and has to hear it from a colleague.
 */
export const portalForgotPassword = <ThrowOnError extends boolean = false>(options: Options<PortalForgotPasswordData, ThrowOnError>): RequestResult<PortalForgotPasswordResponses, PortalForgotPasswordErrors, ThrowOnError> => (options.client ?? client).post<PortalForgotPasswordResponses, PortalForgotPasswordErrors, ThrowOnError>({
    url: '/activist-arc/organization/auth/forgot-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Step 1 of portal sign-in: check the password and email a code
 *
 * Check an email address and password, and email a verification code.
 *
 * This grants nothing on its own. The reply is identical for a wrong password,
 * an unknown address, an invitation not yet accepted, and an account that was
 * suspended or closed.
 */
export const portalLogin = <ThrowOnError extends boolean = false>(options: Options<PortalLoginData, ThrowOnError>): RequestResult<PortalLoginResponses, PortalLoginErrors, ThrowOnError> => (options.client ?? client).post<PortalLoginResponses, PortalLoginErrors, ThrowOnError>({
    url: '/activist-arc/organization/auth/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * End the current portal session
 */
export const portalLogout = <ThrowOnError extends boolean = false>(options?: Options<PortalLogoutData, ThrowOnError>): RequestResult<PortalLogoutResponses, unknown, ThrowOnError> => (options?.client ?? client).post<PortalLogoutResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/auth/logout',
    ...options
});

/**
 * The signed-in portal user
 *
 * Who is signed in, and everywhere they can act.
 *
 * Read from the account and its memberships rather than from the token, so a
 * role change, a new organization or a removal from one lands here on the very
 * next request.
 */
export const portalMe = <ThrowOnError extends boolean = false>(options?: Options<PortalMeData, ThrowOnError>): RequestResult<PortalMeResponses, unknown, ThrowOnError> => (options?.client ?? client).get<PortalMeResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/auth/me',
    ...options
});

/**
 * Exchange a refresh token for a new pair
 *
 * Rotate the token pair.
 *
 * The session is checked as well as the token, so signing out or revoking a
 * session ends access even while the token itself is still in date.
 */
export const portalRefresh = <ThrowOnError extends boolean = false>(options: Options<PortalRefreshData, ThrowOnError>): RequestResult<PortalRefreshResponses, PortalRefreshErrors, ThrowOnError> => (options.client ?? client).post<PortalRefreshResponses, PortalRefreshErrors, ThrowOnError>({
    url: '/activist-arc/organization/auth/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Set a new password with the emailed code
 *
 * Set a new password, then end every session the account has open.
 *
 * Somebody who needs a new password has often lost control of the old one, so
 * a session opened with it must not survive - including the one belonging to
 * the person doing the reset.
 *
 * The code is checked before the new password is compared with the current
 * one. The other order would let anybody test a guess at somebody's password
 * without holding a code at all.
 *
 * The four password rules are enforced by the request schema, so they apply to
 * every role and are named one at a time.
 */
export const portalResetPassword = <ThrowOnError extends boolean = false>(options: Options<PortalResetPasswordData, ThrowOnError>): RequestResult<PortalResetPasswordResponses, PortalResetPasswordErrors, ThrowOnError> => (options.client ?? client).post<PortalResetPasswordResponses, PortalResetPasswordErrors, ThrowOnError>({
    url: '/activist-arc/organization/auth/reset-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send another verification code
 */
export const portalSendCode = <ThrowOnError extends boolean = false>(options: Options<PortalSendCodeData, ThrowOnError>): RequestResult<PortalSendCodeResponses, PortalSendCodeErrors, ThrowOnError> => (options.client ?? client).post<PortalSendCodeResponses, PortalSendCodeErrors, ThrowOnError>({
    url: '/activist-arc/organization/auth/send-code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Step 2 of portal sign-in: exchange the code for tokens
 *
 * Exchange the emailed code for a token pair.
 *
 * The reply says what kind of account this is and lists every organization the
 * person belongs to, each with its status and the role they hold there. So the
 * portal knows whether to open the staff area, drop straight into the one
 * organization, or ask which - without asking a second time. A user of a
 * suspended organization signs in and is shown why, rather than being refused
 * with no reason.
 */
export const portalVerify = <ThrowOnError extends boolean = false>(options: Options<PortalVerifyData, ThrowOnError>): RequestResult<PortalVerifyResponses, PortalVerifyErrors, ThrowOnError> => (options.client ?? client).post<PortalVerifyResponses, PortalVerifyErrors, ThrowOnError>({
    url: '/activist-arc/organization/auth/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * What an invitation link is for (public)
 *
 * Show who an invitation is for, before any password is typed.
 *
 * No sign-in is needed: the person being invited has no account to sign in
 * with, and the link is what proves they were invited.
 */
export const lookUpInvitation = <ThrowOnError extends boolean = false>(options: Options<LookUpInvitationData, ThrowOnError>): RequestResult<LookUpInvitationResponses, LookUpInvitationErrors, ThrowOnError> => (options.client ?? client).get<LookUpInvitationResponses, LookUpInvitationErrors, ThrowOnError>({ url: '/activist-arc/organization/invitations/{token}', ...options });

/**
 * Set a password and activate the account (public)
 *
 * Complete the invitation, setting a password if one is needed.
 *
 * A brand-new account needs one; somebody who already has a portal account
 * and is being invited to a second organization does not, and sending one
 * anyway is refused rather than quietly ignored. `needs_password` on the
 * lookup says which case this is.
 *
 * The membership becomes active and the link is spent in the same
 * transaction, so a second attempt with the same link is answered as used
 * rather than doing the work twice.
 *
 * No token pair is issued here. The person signs in afterwards through the
 * ordinary three steps, which is the flow that emails them a code - accepting
 * an invitation proves they hold the link, not that they hold the mailbox
 * right now.
 */
export const acceptInvitation = <ThrowOnError extends boolean = false>(options: Options<AcceptInvitationData, ThrowOnError>): RequestResult<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError> => (options.client ?? client).post<AcceptInvitationResponses, AcceptInvitationErrors, ThrowOnError>({
    url: '/activist-arc/organization/invitations/{token}/accept',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * This organization's audit log (Super Admin, or staff reading it)
 *
 * Everything recorded about this organization, newest first - including what
 * Activist staff did to it. Staff reading through the X-Organization-Id
 * header see exactly what the Super Admin sees. An Admin is refused.
 *
 * Fields the organization's own pages never show - the internal billing
 * notes, the invoice number, the status reason, the allowance override - are
 * left out of each entry's changes. A staff edit that touched only those
 * still appears, with no field changes listed.
 */
export const portalActivity = <ThrowOnError extends boolean = false>(options?: Options<PortalActivityData, ThrowOnError>): RequestResult<PortalActivityResponses, PortalActivityErrors, ThrowOnError> => (options?.client ?? client).get<PortalActivityResponses, PortalActivityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/activity',
    ...options
});

/**
 * Everybody in this organization's audit log (Super Admin, or staff reading it)
 *
 * The people with entries for this organization, staff included, removed
 * users included.
 */
export const portalActivityActors = <ThrowOnError extends boolean = false>(options?: Options<PortalActivityActorsData, ThrowOnError>): RequestResult<PortalActivityActorsResponses, PortalActivityActorsErrors, ThrowOnError> => (options?.client ?? client).get<PortalActivityActorsResponses, PortalActivityActorsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/activity/actors',
    ...options
});

/**
 * This organization's billing and account standing (Super Admin, or staff reading it)
 *
 * The plan, the money, the contract and the account status.
 *
 * Everything here is read-only except the billing contact, which the update
 * below changes. Nothing here is the internal billing notes or the invoice
 * number.
 */
export const readBilling = <ThrowOnError extends boolean = false>(options?: Options<ReadBillingData, ThrowOnError>): RequestResult<ReadBillingResponses, ReadBillingErrors, ThrowOnError> => (options?.client ?? client).get<ReadBillingResponses, ReadBillingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/billing',
    ...options
});

/**
 * Change this organization's billing contact (Super Admin only)
 *
 * Change who Activist Technologies bills.
 *
 * The contact is replaced whole, not merged: send the complete contact every
 * time, or the parts you leave out will be lost. Sending it as null clears
 * it. Any other field is refused by name - the rest of this page is ours to
 * set, not yours.
 */
export const updateBillingContact = <ThrowOnError extends boolean = false>(options: Options<UpdateBillingContactData, ThrowOnError>): RequestResult<UpdateBillingContactResponses, UpdateBillingContactErrors, ThrowOnError> => (options.client ?? client).patch<UpdateBillingContactResponses, UpdateBillingContactErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/billing',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Invite somebody to this organization (Super Admin only)
 *
 * Add somebody to this organization and email them a link.
 *
 * The role comes from the request here, unlike the staff route, because a
 * Super Admin invites both Admins and further Super Admins.
 *
 * If the address already has a portal account they are added to it - one
 * person, two organizations - and they are not asked for another password.
 * Only two things are refused: an Activist Technologies address, and somebody
 * who is already a member here.
 *
 * If the email cannot be sent the invitation still exists and the reply says
 * so. Resend it rather than inviting the person again, which would leave two
 * live links.
 */
export const invitePortalUser = <ThrowOnError extends boolean = false>(options: Options<InvitePortalUserData, ThrowOnError>): RequestResult<InvitePortalUserResponses, InvitePortalUserErrors, ThrowOnError> => (options.client ?? client).post<InvitePortalUserResponses, InvitePortalUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/invitations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke an invitation (Super Admin only)
 *
 * Call an invitation off.
 *
 * The link stops working and the membership is marked revoked, which releases
 * the address so the same person can be invited again. Their account survives
 * if they belong to another organization, and is closed if this was their
 * only one.
 *
 * Revoking an invitation that is already revoked succeeds and changes nothing,
 * so a repeated request does not look like a failure.
 */
export const revokePortalInvitation = <ThrowOnError extends boolean = false>(options: Options<RevokePortalInvitationData, ThrowOnError>): RequestResult<RevokePortalInvitationResponses, RevokePortalInvitationErrors, ThrowOnError> => (options.client ?? client).delete<RevokePortalInvitationResponses, RevokePortalInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/invitations/{invitation_id}',
    ...options
});

/**
 * Send a fresh invitation link (Super Admin only)
 *
 * Issue a new link and stop the previous one working.
 *
 * The person's place in the organization stays invited throughout; only the
 * link changes.
 */
export const resendPortalInvitation = <ThrowOnError extends boolean = false>(options: Options<ResendPortalInvitationData, ThrowOnError>): RequestResult<ResendPortalInvitationResponses, ResendPortalInvitationErrors, ThrowOnError> => (options.client ?? client).post<ResendPortalInvitationResponses, ResendPortalInvitationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/invitations/{invitation_id}/resend',
    ...options
});

/**
 * This organization's notification allowance this month (any organization role, or staff reading it)
 *
 * How many notifications this organization may send this month, how many it
 * has used, and how many remain.
 *
 * `used` is sent plus scheduled: a scheduled notification takes its place
 * when it is scheduled. `remaining` never goes below zero. The month is the
 * UTC calendar month named by `period_start` and `period_end`.
 */
export const readNotificationAllowance = <ThrowOnError extends boolean = false>(options?: Options<ReadNotificationAllowanceData, ThrowOnError>): RequestResult<ReadNotificationAllowanceResponses, ReadNotificationAllowanceErrors, ThrowOnError> => (options?.client ?? client).get<ReadNotificationAllowanceResponses, ReadNotificationAllowanceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/notification-allowance',
    ...options
});

/**
 * This organization's profile (Super Admin, or staff reading it)
 *
 * Everything the organization may see and change about itself, plus its
 * status and plan name, which it may only see.
 *
 * No cost, contract date, invoice detail or billing contact: those are on the
 * billing route, which US-022 governs separately.
 */
export const readProfile = <ThrowOnError extends boolean = false>(options?: Options<ReadProfileData, ThrowOnError>): RequestResult<ReadProfileResponses, ReadProfileErrors, ThrowOnError> => (options?.client ?? client).get<ReadProfileResponses, ReadProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/profile',
    ...options
});

/**
 * Update this organization's profile (Super Admin only)
 *
 * Change part of the profile.
 *
 * Only the fields you send are changed. A field you leave out keeps its
 * current value; a field you send as null is cleared. A field name that does
 * not exist here - the handle, the status, anything commercial, or either
 * image - is refused rather than quietly ignored.
 *
 * The contact objects are replaced whole, not merged. Send the complete
 * contact every time, or the parts you leave out will be lost. Social links
 * are one object and behave the same way.
 */
export const updateProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateProfileData, ThrowOnError>): RequestResult<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError> => (options.client ?? client).patch<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove this organization's cover image (Super Admin only)
 *
 * Clear the cover image.
 */
export const removeCoverImage = <ThrowOnError extends boolean = false>(options?: Options<RemoveCoverImageData, ThrowOnError>): RequestResult<RemoveCoverImageResponses, RemoveCoverImageErrors, ThrowOnError> => (options?.client ?? client).delete<RemoveCoverImageResponses, RemoveCoverImageErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/profile/cover-image',
    ...options
});

/**
 * Upload this organization's cover image (Super Admin only, max 5 MB)
 *
 * Replace the cover image. Same rules as the logo, with a larger limit.
 */
export const uploadCoverImage = <ThrowOnError extends boolean = false>(options: Options<UploadCoverImageData, ThrowOnError>): RequestResult<UploadCoverImageResponses, UploadCoverImageErrors, ThrowOnError> => (options.client ?? client).post<UploadCoverImageResponses, UploadCoverImageErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/profile/cover-image',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Remove this organization's logo (Super Admin only)
 *
 * Clear the logo. Removing one that was never set is not an error.
 */
export const removeLogo = <ThrowOnError extends boolean = false>(options?: Options<RemoveLogoData, ThrowOnError>): RequestResult<RemoveLogoResponses, RemoveLogoErrors, ThrowOnError> => (options?.client ?? client).delete<RemoveLogoResponses, RemoveLogoErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/profile/logo',
    ...options
});

/**
 * Upload this organization's logo (Super Admin only, max 2 MB)
 *
 * Replace the logo.
 *
 * The file is checked by its content, not its name: a renamed SVG or GIF is
 * refused. Any previous logo is deleted once the new one is stored.
 */
export const uploadLogo = <ThrowOnError extends boolean = false>(options: Options<UploadLogoData, ThrowOnError>): RequestResult<UploadLogoResponses, UploadLogoErrors, ThrowOnError> => (options.client ?? client).post<UploadLogoResponses, UploadLogoErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/profile/logo',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * The organization's portal users and invitations
 *
 * Everybody who belongs to this organization, and where each of them is.
 *
 * Users and invitations are one list, because they are one record: somebody
 * invited and somebody signing in daily are the same membership at different
 * points in its life.
 *
 * Each row carries the role held **here**. Somebody who also belongs to
 * another organization appears once, with this organization's role, and the
 * other one is not named.
 *
 * Revoked and removed people are included and marked as past rather than
 * hidden. Hiding them would leave somebody wondering why an address cannot be
 * invited again, which is exactly what the history answers.
 *
 * No Activist Technologies account can appear here. Staff hold no
 * memberships, so there is nothing for the query to find.
 */
export const listPortalUsers = <ThrowOnError extends boolean = false>(options?: Options<ListPortalUsersData, ThrowOnError>): RequestResult<ListPortalUsersResponses, ListPortalUsersErrors, ThrowOnError> => (options?.client ?? client).get<ListPortalUsersResponses, ListPortalUsersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/users',
    ...options
});

/**
 * Remove somebody from this organization (Super Admin only)
 *
 * Take somebody out of this organization.
 *
 * A soft removal: the record is kept and marked removed, so the list can
 * still explain what happened to an address.
 *
 * If they belong to another organization their account and their sessions
 * carry on - they simply stop being able to act here from their next request.
 * If this was their only one the account is closed and every session ends, so
 * a token already in their hands stops working immediately.
 *
 * Refused when it would leave no Super Admin, and refused when it is your own
 * membership - which needs another Super Admin to undo, so the cost of a
 * mis-click on your own row is high.
 */
export const removePortalUser = <ThrowOnError extends boolean = false>(options: Options<RemovePortalUserData, ThrowOnError>): RequestResult<RemovePortalUserResponses, RemovePortalUserErrors, ThrowOnError> => (options.client ?? client).delete<RemovePortalUserResponses, RemovePortalUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/users/{user_id}',
    ...options
});

/**
 * Change somebody's role in this organization (Super Admin only)
 *
 * Promote somebody to Super Admin, or step them down to Admin.
 *
 * It applies to this organization only. Somebody who is also an Admin
 * elsewhere stays an Admin there; that is a different membership.
 *
 * It takes effect on their next request: every route re-reads the memberships
 * rather than trusting a token, so they do not have to sign in again.
 *
 * Refused when it would leave this organization with no Super Admin,
 * including when the person stepping down is you.
 */
export const changePortalUserRole = <ThrowOnError extends boolean = false>(options: Options<ChangePortalUserRoleData, ThrowOnError>): RequestResult<ChangePortalUserRoleResponses, ChangePortalUserRoleErrors, ThrowOnError> => (options.client ?? client).patch<ChangePortalUserRoleResponses, ChangePortalUserRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/organization/portal/users/{user_id}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Polling Places
 *
 * Fetch polling places (Paginated).
 *
 * Accepts optional latitude/longitude for direct coordinate lookup.
 * If coordinates are provided, uses them to query polling locations.
 * Otherwise, falls back to user's profile address.
 */
export const getPollingPlaces = <ThrowOnError extends boolean = false>(options?: Options<GetPollingPlacesData, ThrowOnError>): RequestResult<GetPollingPlacesResponses, GetPollingPlacesErrors, ThrowOnError> => (options?.client ?? client).get<GetPollingPlacesResponses, GetPollingPlacesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/polling-places',
    ...options
});

/**
 * Get Current President's Bills
 *
 * Retrieve bills signed or vetoed by the current president (Donald J. Trump).
 *
 * This is a convenience endpoint that automatically routes to the current president
 * without requiring the president name in the URL.
 *
 * **Features:**
 * - Filter by action type: signed, vetoed, or vetoed (but overridden)
 * - Pagination support
 * - Filter by topic category
 * - Filter by date range (enactment date)
 * - Includes veto information (veto date, override attempts, override results)
 * - Metadata includes counts of signed/vetoed/overridden bills
 *
 * **Action Types:**
 * - `all` - All bills (signed + vetoed + vetoed_overridden)
 * - `signed` - Bills signed into law
 * - `vetoed` - Bills vetoed (veto stands)
 * - `vetoed_overridden` - Bills vetoed but override passed
 *
 * **Example:**
 * ```
 * GET /president/current/bills?action_type=signed&topic=tax&limit=10
 * GET /president/current/bills?action_type=vetoed
 * ```
 */
export const getCurrentPresidentBills = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentPresidentBillsData, ThrowOnError>): RequestResult<GetCurrentPresidentBillsResponses, GetCurrentPresidentBillsErrors, ThrowOnError> => (options?.client ?? client).get<GetCurrentPresidentBillsResponses, GetCurrentPresidentBillsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/president/current/bills',
    ...options
});

/**
 * Get Current President's Executive Orders
 *
 * Retrieve executive orders for the current president (Donald Trump).
 *
 * This is a convenience endpoint that automatically routes to the current president
 * without requiring the president name in the URL.
 *
 * **Features:**
 * - Pagination support
 * - Filter by topic (e.g., "immigration", "healthcare")
 * - Filter by date range (signing date)
 * - Sort by signing date, order number, or publication date
 * - Includes associated agencies and related executive orders
 *
 * **Example:**
 * ```
 * GET /president/current/executive-orders?topic=immigration&limit=10
 * ```
 */
export const getCurrentPresidentExecutiveOrders = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentPresidentExecutiveOrdersData, ThrowOnError>): RequestResult<GetCurrentPresidentExecutiveOrdersResponses, GetCurrentPresidentExecutiveOrdersErrors, ThrowOnError> => (options?.client ?? client).get<GetCurrentPresidentExecutiveOrdersResponses, GetCurrentPresidentExecutiveOrdersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/president/current/executive-orders',
    ...options
});

/**
 * Get Bills by President
 *
 * Retrieve bills signed or vetoed by a specific president.
 *
 * **Supported Presidents:**
 * - Trump / Donald Trump / Donald J. Trump
 * - Biden / Joe Biden / Joseph R. Biden
 * - Obama / Barack Obama
 *
 * **Features:**
 * - Filter by action type: signed, vetoed, or vetoed (but overridden)
 * - Pagination support
 * - Filter by topic category
 * - Filter by date range (enactment date)
 * - Includes veto information (veto date, override attempts, override results)
 * - Metadata includes counts of signed/vetoed/overridden bills
 *
 * **Action Types:**
 * - `all` - All bills (signed + vetoed + vetoed_overridden)
 * - `signed` - Bills signed into law
 * - `vetoed` - Bills vetoed (veto stands)
 * - `vetoed_overridden` - Bills vetoed but override passed
 *
 * **Example:**
 * ```
 * GET /president/trump/bills?action_type=signed&topic=tax&limit=10
 * GET /president/trump/bills?action_type=vetoed
 * ```
 */
export const getBills = <ThrowOnError extends boolean = false>(options: Options<GetBillsData, ThrowOnError>): RequestResult<GetBillsResponses, GetBillsErrors, ThrowOnError> => (options.client ?? client).get<GetBillsResponses, GetBillsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/president/{president_name}/bills',
    ...options
});

/**
 * Get Executive Orders by President
 *
 * Retrieve all executive orders issued by a specific president.
 *
 * **Supported Presidents:**
 * - Trump / Donald Trump / Donald J. Trump
 * - Biden / Joe Biden / Joseph R. Biden
 * - Obama / Barack Obama
 *
 * **Features:**
 * - Pagination support
 * - Filter by topic (e.g., "immigration", "healthcare")
 * - Filter by date range (signing date)
 * - Sort by signing date, order number, or publication date
 * - Includes associated agencies and related executive orders
 *
 * **Example:**
 * ```
 * GET /president/trump/executive-orders?topic=immigration&limit=10
 * ```
 */
export const getExecutiveOrders = <ThrowOnError extends boolean = false>(options: Options<GetExecutiveOrdersData, ThrowOnError>): RequestResult<GetExecutiveOrdersResponses, GetExecutiveOrdersErrors, ThrowOnError> => (options.client ?? client).get<GetExecutiveOrdersResponses, GetExecutiveOrdersErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/president/{president_name}/executive-orders',
    ...options
});

/**
 * Get User Profile
 *
 * Get the current user's full profile, aggregating:
 * - Basic user info (including `political_party`)
 * - Survey-derived classification keys (Classifier, Top Issues, Voting, Advocacy)
 * - Following list (officials and bills the user follows)
 * - Voter record (registered address, districts, party from TargetSmart)
 * - Voting history (parsed from vote_history JSONB)
 * - Action history (logged calls and emails)
 *
 * **Authentication Required** — Bearer token in Authorization header.
 */
export const getProfile = <ThrowOnError extends boolean = false>(options?: Options<GetProfileData, ThrowOnError>): RequestResult<GetProfileResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetProfileResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/profile',
    ...options
});

/**
 * Refresh User's Elected Officials
 *
 * Refresh elected officials for the current user.
 * Fetches officials from BallotReady for the user's address and enriches with Congress.gov data.
 *
 * **Query Parameters:**
 * - **force** (optional): If true, force re-ingestion even if officials were recently fetched
 *
 * **Authentication Required** — Bearer token in Authorization header.
 */
export const refreshUserOfficials = <ThrowOnError extends boolean = false>(options?: Options<RefreshUserOfficialsData, ThrowOnError>): RequestResult<RefreshUserOfficialsResponses, RefreshUserOfficialsErrors, ThrowOnError> => (options?.client ?? client).post<RefreshUserOfficialsResponses, RefreshUserOfficialsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/profile/refresh-officials',
    ...options
});

/**
 * Get or fetch a federal bill by Congress.gov identifiers
 *
 * Return full bill detail for any federal bill, identified by its Congress.gov coordinates.
 *
 * **Cache-first behaviour:**
 * - If the bill is already in the local DB it is returned immediately (`source: "cache"`).
 * - If not, it is fetched from Congress.gov on-demand, fully enriched (same pipeline as
 * the daily cron job), saved to the DB, and returned (`source: "live"`).  The first
 * call for an uncached bill may take several seconds; all subsequent calls are instant.
 *
 * **Typical use-case:** the `related_bills` field of a bill card contains references like
 * `{"type": "HR", "number": 1077, "congress": 119}`.  The UI calls this endpoint to
 * display the related bill detail without waiting for the next nightly ingestion run.
 *
 * **Path parameters:**
 * - `congress`    — integer congress number, e.g. `119`
 * - `bill_type`   — case-insensitive type code: `HR`, `S`, `HRES`, `SRES`, `HJRES`,
 * `SJRES`, `HCONRES`, `SCONRES`
 * - `bill_number` — numeric bill number as a string, e.g. `1077`
 *
 * **Errors:**
 * - `400` — invalid bill type code
 * - `404` — bill does not exist on Congress.gov
 * - `503` — Congress.gov API is temporarily unavailable
 */
export const getOrFetchBill = <ThrowOnError extends boolean = false>(options: Options<GetOrFetchBillData, ThrowOnError>): RequestResult<GetOrFetchBillResponses, GetOrFetchBillErrors, ThrowOnError> => (options.client ?? client).get<GetOrFetchBillResponses, GetOrFetchBillErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/research/bills/{congress}/{bill_type}/{bill_number}',
    ...options
});

/**
 * Debug Personalized Scoring
 *
 * **DEBUG ENDPOINT**: Shows how personalized scoring works on real items
 *
 * Returns sample items from the database with:
 * - Raw item data (title, jurisdiction, topics)
 * - Calculated personalized_score
 * - Score breakdown (topic score + geography score)
 * - Explanation of why each score was assigned
 *
 * Useful for debugging personalization logic.
 */
export const debugPersonalizedScoring = <ThrowOnError extends boolean = false>(options?: Options<DebugPersonalizedScoringData, ThrowOnError>): RequestResult<DebugPersonalizedScoringResponses, DebugPersonalizedScoringErrors, ThrowOnError> => (options?.client ?? client).get<DebugPersonalizedScoringResponses, DebugPersonalizedScoringErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/research/debug-scoring',
    ...options
});

/**
 * Get Recommended Research
 *
 * Get recommended pages/items for the Research landing page.
 * Includes recently viewed items and AI-driven recommendations.
 */
export const getRecommendedResearch = <ThrowOnError extends boolean = false>(options?: Options<GetRecommendedResearchData, ThrowOnError>): RequestResult<GetRecommendedResearchResponses, GetRecommendedResearchErrors, ThrowOnError> => (options?.client ?? client).get<GetRecommendedResearchResponses, GetRecommendedResearchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/research/recommended',
    ...options
});

/**
 * Search Research
 *
 * Search and filter research items by keyword, type, topic, and/or state.
 *
 * **searchText**: General keyword search across all text fields (title, description, summary, name).
 * Case-insensitive partial matching.
 *
 * **topics**: Accepts freetext (e.g. 'health', 'climate reform') — expanded to canonical
 * topic names and matched via a 4-layer strategy: L1 topic_category, L2 primary_issue_tags,
 * L3 secondary_issue_tags, L4 title text.
 *
 * **Personalization**: When browsing (no searchText), results are personalized based on user
 * survey responses and preferences. When searching, results are ordered by relevance to search terms.
 *
 * Returns paginated results.
 */
export const searchResearch = <ThrowOnError extends boolean = false>(options?: Options<SearchResearchData, ThrowOnError>): RequestResult<SearchResearchResponses, SearchResearchErrors, ThrowOnError> => (options?.client ?? client).get<SearchResearchResponses, SearchResearchErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/research/search',
    ...options
});

/**
 * Get State Election Resource
 *
 * Get the election resources link for the current user's state.
 *
 * Looks up the user's state (from their profile address) in the regions table
 * and returns the corresponding state election resources URL.
 */
export const getStateElectionResource = <ThrowOnError extends boolean = false>(options?: Options<GetStateElectionResourceData, ThrowOnError>): RequestResult<GetStateElectionResourceResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetStateElectionResourceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/state-resources',
    ...options
});

/**
 * Submit a bug report with optional screenshots
 *
 * Submit a bug report. Accepts multipart/form-data.
 * Screenshots are uploaded to S3 and their URLs are saved.
 */
export const submitBugReport = <ThrowOnError extends boolean = false>(options: Options<SubmitBugReportData, ThrowOnError>): RequestResult<SubmitBugReportResponses, SubmitBugReportErrors, ThrowOnError> => (options.client ?? client).post<SubmitBugReportResponses, SubmitBugReportErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/support/bug-report',
    ...options,
    headers: {
        'Content-Type': null,
        ...options.headers
    }
});

/**
 * Submit a general support/contact request
 *
 * Submit a general support request. Accepts multipart/form-data.
 * An optional attachment can be uploaded.
 * An automated alert is sent to the support team.
 */
export const submitContactRequest = <ThrowOnError extends boolean = false>(options?: Options<SubmitContactRequestData, ThrowOnError>): RequestResult<SubmitContactRequestResponses, SubmitContactRequestErrors, ThrowOnError> => (options?.client ?? client).post<SubmitContactRequestResponses, SubmitContactRequestErrors, ThrowOnError>({
    ...formDataBodySerializer,
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/support/contact',
    ...options,
    headers: {
        'Content-Type': null,
        ...options?.headers
    }
});

/**
 * Get official support contact information (email and phone)
 *
 * Returns the official support email and phone number.
 * Used for displaying "Email Us" or "Call Us" options in the UI.
 */
export const getSupportContactInfo = <ThrowOnError extends boolean = false>(options?: Options<GetSupportContactInfoData, ThrowOnError>): RequestResult<GetSupportContactInfoResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetSupportContactInfoResponses, unknown, ThrowOnError>({ url: '/activist-arc/support/contact-info', ...options });

/**
 * Get Onboarding Survey
 *
 * Get the onboarding survey questions with user's existing answers (if any)
 *
 * **Authentication Required** - Returns survey structure with user's saved answers merged in.
 *
 * For each question:
 * - If answered: includes `answer` field with user's selection
 * - If not answered: `answer` is null
 */
export const getOnboardingSurvey = <ThrowOnError extends boolean = false>(options?: Options<GetOnboardingSurveyData, ThrowOnError>): RequestResult<GetOnboardingSurveyResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetOnboardingSurveyResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/survey/onboarding',
    ...options
});

/**
 * Get User Profile Debug
 *
 * **DEBUG ENDPOINT**: View extracted survey data and user profile
 *
 * Shows exactly what values are extracted from the survey for personalization:
 * - Q3: General interests (topics)
 * - Q4: Priority topics (ranked 1-5)
 * - Q5: Deprioritized topics
 * - Q7: Issue scope (local/national/both)
 * - State: From user address
 * - Behavioral topics: From favorites/follows
 *
 * Useful for debugging personalization issues.
 */
export const getUserProfileDebug = <ThrowOnError extends boolean = false>(options?: Options<GetUserProfileDebugData, ThrowOnError>): RequestResult<GetUserProfileDebugResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetUserProfileDebugResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/survey/profile-debug',
    ...options
});

/**
 * Submit Survey
 *
 * Submit survey responses (requires authentication)
 *
 * Submits user's survey responses. Status is auto-calculated:
 * - **COMPLETED**: All required questions are answered
 * - **IN_PROGRESS**: Some required questions are still unanswered
 *
 * Responses are merged with existing answers, so partial submissions are allowed.
 */
export const submitSurvey = <ThrowOnError extends boolean = false>(options: Options<SubmitSurveyData, ThrowOnError>): RequestResult<SubmitSurveyResponses, SubmitSurveyErrors, ThrowOnError> => (options.client ?? client).post<SubmitSurveyResponses, SubmitSurveyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/survey/submit',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Latest Task
 *
 * Get the most recent task of a specific type for the current user.
 *
 * Useful for checking if feed generation is complete after survey submission.
 *
 * Example: GET /tasks/latest/initiate_feed_and_recommendation
 */
export const getLatestTask = <ThrowOnError extends boolean = false>(options: Options<GetLatestTaskData, ThrowOnError>): RequestResult<GetLatestTaskResponses, GetLatestTaskErrors, ThrowOnError> => (options.client ?? client).get<GetLatestTaskResponses, GetLatestTaskErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/tasks/latest/{task_type}',
    ...options
});

/**
 * Get My Tasks
 *
 * Get background tasks for the current user.
 *
 * Returns recent tasks with their status, progress, and results.
 * Use this endpoint to poll for completion of async operations like
 * feed generation after survey completion.
 */
export const getMyTasks = <ThrowOnError extends boolean = false>(options?: Options<GetMyTasksData, ThrowOnError>): RequestResult<GetMyTasksResponses, GetMyTasksErrors, ThrowOnError> => (options?.client ?? client).get<GetMyTasksResponses, GetMyTasksErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/tasks/status',
    ...options
});

/**
 * Get Task Status
 *
 * Get status of a specific background task by ID.
 *
 * Returns detailed status including progress and result summary.
 */
export const getTaskStatus = <ThrowOnError extends boolean = false>(options: Options<GetTaskStatusData, ThrowOnError>): RequestResult<GetTaskStatusResponses, GetTaskStatusErrors, ThrowOnError> => (options.client ?? client).get<GetTaskStatusResponses, GetTaskStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/tasks/status/{task_id}',
    ...options
});

/**
 * Untrack Item
 *
 * Stop tracking an item.
 *
 * **Authentication:** Required
 *
 * **Query Parameters:**
 * - `item_id` (required): UUID of the item
 * - `item_type` (required): Type of content (bill, candidate, elected_official)
 *
 * **Error Responses:**
 * - `404 Not Found`: Item not being tracked
 * - `400 Bad Request`: Invalid parameters
 * - `401 Unauthorized`: Missing or invalid token
 */
export const untrackItem = <ThrowOnError extends boolean = false>(options: Options<UntrackItemData, ThrowOnError>): RequestResult<UntrackItemResponses, UntrackItemErrors, ThrowOnError> => (options.client ?? client).delete<UntrackItemResponses, UntrackItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/track/item',
    ...options
});

/**
 * Track Item
 *
 * Start tracking an item (bill, candidate, official) - simplified (notifies on ALL changes).
 *
 * **Authentication:** Required
 *
 * **Supported Item Types:**
 * - `bill`: Track bill status changes (all changes trigger notifications)
 * - `candidate`: Track election results
 * - `elected_official`: Track reelection announcements and results
 *
 * **Notifications:**
 * - ALL changes trigger immediate notifications
 * - No configuration needed - system notifies on everything
 * - To stop notifications, untrack the item
 *
 * **Error Responses:**
 * - `400 Bad Request`: Invalid item_type or unsupported type
 * - `404 Not Found`: Item does not exist
 * - `409 Conflict`: Item already tracked
 * - `401 Unauthorized`: Missing or invalid token
 */
export const trackItem = <ThrowOnError extends boolean = false>(options: Options<TrackItemData, ThrowOnError>): RequestResult<TrackItemResponses, TrackItemErrors, ThrowOnError> => (options.client ?? client).post<TrackItemResponses, TrackItemErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/track/item',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Tracked Items
 *
 * Get all tracked items for the current user.
 *
 * **Authentication:** Required
 *
 * **Query Parameters:**
 * - `item_type` (optional): Filter by specific type (bill, candidate, elected_official)
 * - `is_active` (optional): Filter by active status (default: true)
 * - `limit` (optional): Max results (default: 100, max: 500)
 * - `offset` (optional): Pagination offset (default: 0)
 *
 * **Returns:**
 * List of tracked items with full details, pagination info, and tracking metadata.
 *
 * **Error Responses:**
 * - `401 Unauthorized`: Missing or invalid token
 */
export const getTrackedItems = <ThrowOnError extends boolean = false>(options?: Options<GetTrackedItemsData, ThrowOnError>): RequestResult<GetTrackedItemsResponses, GetTrackedItemsErrors, ThrowOnError> => (options?.client ?? client).get<GetTrackedItemsResponses, GetTrackedItemsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/track/items',
    ...options
});

/**
 * Toggle Favorite
 *
 * Toggle favorite status for an item (Bill, Person, News, etc.)
 */
export const toggleFavorite = <ThrowOnError extends boolean = false>(options: Options<ToggleFavoriteData, ThrowOnError>): RequestResult<ToggleFavoriteResponses, ToggleFavoriteErrors, ThrowOnError> => (options.client ?? client).post<ToggleFavoriteResponses, ToggleFavoriteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/favorite',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Toggle Follow
 *
 * Toggle follow status for an entity (Bill, Elected Official)
 */
export const toggleFollow = <ThrowOnError extends boolean = false>(options: Options<ToggleFollowData, ThrowOnError>): RequestResult<ToggleFollowResponses, ToggleFollowErrors, ThrowOnError> => (options.client ?? client).post<ToggleFollowResponses, ToggleFollowErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/follow',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get My Profile
 *
 * Get current user's full profile including voter details.
 */
export const getMyProfile = <ThrowOnError extends boolean = false>(options?: Options<GetMyProfileData, ThrowOnError>): RequestResult<GetMyProfileResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetMyProfileResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me',
    ...options
});

/**
 * Update My Profile
 *
 * Update current user's profile information
 */
export const updateMyProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateMyProfileData, ThrowOnError>): RequestResult<UpdateMyProfileResponses, UpdateMyProfileErrors, ThrowOnError> => (options.client ?? client).post<UpdateMyProfileResponses, UpdateMyProfileErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Clear all advocacy action history
 *
 * Permanently delete all logs of calls and emails the user has made (ActivistAction).
 */
export const clearAdvocacyHistory = <ThrowOnError extends boolean = false>(options?: Options<ClearAdvocacyHistoryData, ThrowOnError>): RequestResult<ClearAdvocacyHistoryResponses, unknown, ThrowOnError> => (options?.client ?? client).delete<ClearAdvocacyHistoryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/actions',
    ...options
});

/**
 * Get analytics & diagnostics consent
 *
 * Get the current user's analytics & diagnostics consent preference.
 *
 * Default is `true` (opted in). When set to `false`, the app should
 * disable analytics tracking SDKs for this user.
 */
export const getAnalyticsPreference = <ThrowOnError extends boolean = false>(options?: Options<GetAnalyticsPreferenceData, ThrowOnError>): RequestResult<GetAnalyticsPreferenceResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAnalyticsPreferenceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/analytics',
    ...options
});

/**
 * Update analytics & diagnostics consent
 *
 * Update the current user's analytics & diagnostics consent.
 *
 * Set `analytics_enabled` to `false` to opt out of analytics tracking.
 */
export const updateAnalyticsPreference = <ThrowOnError extends boolean = false>(options: Options<UpdateAnalyticsPreferenceData, ThrowOnError>): RequestResult<UpdateAnalyticsPreferenceResponses, UpdateAnalyticsPreferenceErrors, ThrowOnError> => (options.client ?? client).patch<UpdateAnalyticsPreferenceResponses, UpdateAnalyticsPreferenceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/analytics',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get All Ballot Tracking
 *
 * Get ballot tracking for all elections where user has initiated VBM request.
 *
 * Returns:
 * List of BallotTrackingResponse (one per election)
 *
 * Example cURL:
 * curl -X GET \
 * http://localhost:8000/activist-arc/users/me/ballot-tracking/all \
 * -H "Authorization: Bearer <token>"
 */
export const getAllBallotTracking = <ThrowOnError extends boolean = false>(options?: Options<GetAllBallotTrackingData, ThrowOnError>): RequestResult<GetAllBallotTrackingResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetAllBallotTrackingResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/ballot-tracking/all',
    ...options
});

/**
 * Get contact and recovery details
 *
 * Return the user's primary email and optional recovery phone.
 */
export const getContactRecovery = <ThrowOnError extends boolean = false>(options?: Options<GetContactRecoveryData, ThrowOnError>): RequestResult<GetContactRecoveryResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetContactRecoveryResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/contact-recovery',
    ...options
});

/**
 * Remove FCM device token (call on logout)
 *
 * Remove an FCM device token (call this on logout).
 *
 * Ensures revoked devices no longer receive push notifications.
 */
export const removeDeviceToken = <ThrowOnError extends boolean = false>(options: Options<RemoveDeviceTokenData, ThrowOnError>): RequestResult<RemoveDeviceTokenResponses, RemoveDeviceTokenErrors, ThrowOnError> => (options.client ?? client).delete<RemoveDeviceTokenResponses, RemoveDeviceTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/device-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Register FCM device token for push notifications
 *
 * Register an FCM device token for the current user.
 *
 * The mobile app should call this on startup (after login) to ensure
 * push notifications reach this device. Duplicate tokens are ignored.
 */
export const registerDeviceToken = <ThrowOnError extends boolean = false>(options: Options<RegisterDeviceTokenData, ThrowOnError>): RequestResult<RegisterDeviceTokenResponses, RegisterDeviceTokenErrors, ThrowOnError> => (options.client ?? client).post<RegisterDeviceTokenResponses, RegisterDeviceTokenErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/device-token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Ballot Request Completed
 *
 * Mark that user completed VoteAmerica VBM request for a specific election.
 *
 * This is Step 1 of the 5-step ballot tracking process.
 *
 * Args:
 * election_id: UUID or Base64-encoded BallotReady GID of the election
 * request: VBMRequestCompletedRequest with voting_method
 * current_user: Authenticated user (from JWT)
 * db: Database session
 *
 * Returns:
 * BallotTrackingResponse with current status
 *
 * Example cURL:
 * curl -X POST \
 * http://localhost:8000/activist-arc/users/me/elections/60466813-a3a3-4afe-a0c2-bc0ee2e71027/ballot-request-completed \
 * -H "Authorization: Bearer <token>" \
 * -H "Content-Type: application/json" \
 * -d '{"voting_method": "Vote by Mail"}'
 */
export const markBallotRequestCompleted = <ThrowOnError extends boolean = false>(options: Options<MarkBallotRequestCompletedData, ThrowOnError>): RequestResult<MarkBallotRequestCompletedResponses, MarkBallotRequestCompletedErrors, ThrowOnError> => (options.client ?? client).post<MarkBallotRequestCompletedResponses, MarkBallotRequestCompletedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/elections/{election_id}/ballot-request-completed',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Ballot Status
 *
 * Get ballot tracking status for a specific election.
 *
 * Shows 5-step progress:
 * 1. User completed VoteAmerica request
 * 2. Request received by state
 * 3. Ballot mailed to user
 * 4. Ballot received by state
 * 5. Ballot counted
 *
 * Args:
 * election_id: UUID or Base64-encoded BallotReady GID of the election
 * current_user: Authenticated user (from JWT)
 * db: Database session
 *
 * Returns:
 * BallotTrackingResponse. When no tracking record exists yet this still
 * returns 200 with a synthetic payload — steps marked "n/a" for in-person
 * voters, or "not_started" (with voting_method null) for a user who hasn't
 * selected a method yet.
 *
 * Example cURL:
 * curl -X GET \
 * http://localhost:8000/activist-arc/users/me/elections/60466813-a3a3-4afe-a0c2-bc0ee2e71027/ballot-status \
 * -H "Authorization: Bearer <token>"
 */
export const getBallotStatus = <ThrowOnError extends boolean = false>(options: Options<GetBallotStatusData, ThrowOnError>): RequestResult<GetBallotStatusResponses, GetBallotStatusErrors, ThrowOnError> => (options.client ?? client).get<GetBallotStatusResponses, GetBallotStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/elections/{election_id}/ballot-status',
    ...options
});

/**
 * Update primary email address
 *
 * Update the user's primary email address.
 * Requires the current password for security verification.
 */
export const updateEmail = <ThrowOnError extends boolean = false>(options: Options<UpdateEmailData, ThrowOnError>): RequestResult<UpdateEmailResponses, UpdateEmailErrors, ThrowOnError> => (options.client ?? client).patch<UpdateEmailResponses, UpdateEmailErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/email',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get login alert preference
 *
 * Get the current user's login alert preference.
 *
 * When enabled, the user receives an email alert whenever a new device logs in.
 */
export const getLoginAlertPreference = <ThrowOnError extends boolean = false>(options?: Options<GetLoginAlertPreferenceData, ThrowOnError>): RequestResult<GetLoginAlertPreferenceResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetLoginAlertPreferenceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/login-alert',
    ...options
});

/**
 * Toggle login alert notifications
 *
 * Toggle login alert emails on or off.
 *
 * When `login_alert_enabled` is `true`, the user gets an email whenever
 * a new session is created (new device login). Set to `false` to disable.
 */
export const updateLoginAlertPreference = <ThrowOnError extends boolean = false>(options: Options<UpdateLoginAlertPreferenceData, ThrowOnError>): RequestResult<UpdateLoginAlertPreferenceResponses, UpdateLoginAlertPreferenceErrors, ThrowOnError> => (options.client ?? client).patch<UpdateLoginAlertPreferenceResponses, UpdateLoginAlertPreferenceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/login-alert',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Mark Pav Request Completed
 *
 * Mark that user completed VoteAmerica PAV (Permanent Absentee Voter) request.
 *
 * PAV is voter-level (not election-specific). Once enrolled, user automatically
 * receives absentee ballots for all future elections.
 *
 * This endpoint automatically:
 * 1. Sets pav_request_completed = True
 * 2. Sets default_voting_method = "Permanent Absentee Voting"
 * 3. Updates/creates ballot tracking records for upcoming elections with PAV method
 *
 * Returns:
 * {"pav_request_completed": True, "pav_request_completed_at": "ISO timestamp",
 * "default_voting_method": "Permanent Absentee Voting"}
 *
 * Example cURL:
 * curl -X POST \
 * http://localhost:8000/activist-arc/users/me/pav-request-completed \
 * -H "Authorization: Bearer <token>"
 */
export const markPavRequestCompleted = <ThrowOnError extends boolean = false>(options?: Options<MarkPavRequestCompletedData, ThrowOnError>): RequestResult<MarkPavRequestCompletedResponses, unknown, ThrowOnError> => (options?.client ?? client).post<MarkPavRequestCompletedResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/pav-request-completed',
    ...options
});

/**
 * Get Pav Status
 *
 * Get Permanent Absentee Voter (PAV) enrollment status.
 *
 * Returns:
 * - pav_request_completed: Whether user marked VoteAmerica request as complete
 * - pav_enrolled: Whether user is enrolled as PAV (from Snowflake vb__vf_pav)
 * - ballots: Ballot tracking for all elections (Steps 3-5 same as VBM)
 * - disclaimer: Legal disclaimer with state resource link
 *
 * Example cURL:
 * curl -X GET \
 * http://localhost:8000/activist-arc/users/me/pav-status \
 * -H "Authorization: Bearer <token>"
 */
export const getPavStatus = <ThrowOnError extends boolean = false>(options?: Options<GetPavStatusData, ThrowOnError>): RequestResult<GetPavStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetPavStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/pav-status',
    ...options
});

/**
 * Update recovery phone number
 *
 * Update the user's optional recovery phone number.
 */
export const updatePhone = <ThrowOnError extends boolean = false>(options: Options<UpdatePhoneData, ThrowOnError>): RequestResult<UpdatePhoneResponses, UpdatePhoneErrors, ThrowOnError> => (options.client ?? client).patch<UpdatePhoneResponses, UpdatePhoneErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/phone',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get AI recommendations preference
 *
 * Return whether AI recommendations are enabled.
 */
export const getRecommendationsPreference = <ThrowOnError extends boolean = false>(options?: Options<GetRecommendationsPreferenceData, ThrowOnError>): RequestResult<GetRecommendationsPreferenceResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetRecommendationsPreferenceResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/recommendations-preference',
    ...options
});

/**
 * Update AI recommendations preference
 *
 * Update AI recommendations feature toggle.
 */
export const updateRecommendationsPreference = <ThrowOnError extends boolean = false>(options: Options<UpdateRecommendationsPreferenceData, ThrowOnError>): RequestResult<UpdateRecommendationsPreferenceResponses, UpdateRecommendationsPreferenceErrors, ThrowOnError> => (options.client ?? client).patch<UpdateRecommendationsPreferenceResponses, UpdateRecommendationsPreferenceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/recommendations-preference',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get linked voter record details
 *
 * Return whether the user is linked to a TargetSmart voter file, and if so, their details.
 */
export const getVoterRecord = <ThrowOnError extends boolean = false>(options?: Options<GetVoterRecordData, ThrowOnError>): RequestResult<GetVoterRecordResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetVoterRecordResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/voter-record',
    ...options
});

/**
 * Manually attempt to link voter file
 *
 * Trigger a fresh TargetSmart lookup using the user's saved profile details.
 */
export const linkVoterRecord = <ThrowOnError extends boolean = false>(options?: Options<LinkVoterRecordData, ThrowOnError>): RequestResult<LinkVoterRecordResponses, unknown, ThrowOnError> => (options?.client ?? client).post<LinkVoterRecordResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/voter-record/link',
    ...options
});

/**
 * Unlink the current user's voter record
 *
 * Clear the signed-in user's voter-record link (returns to NOT_ATTEMPTED). Idempotent.
 */
export const unlinkVoterRecord = <ThrowOnError extends boolean = false>(options?: Options<UnlinkVoterRecordData, ThrowOnError>): RequestResult<UnlinkVoterRecordResponses, unknown, ThrowOnError> => (options?.client ?? client).post<UnlinkVoterRecordResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/voter-record/unlink',
    ...options
});

/**
 * Get Voting Method
 *
 * Get the current user's default voting method preference,
 * and context about its availability for the next election.
 */
export const getVotingMethod = <ThrowOnError extends boolean = false>(options?: Options<GetVotingMethodData, ThrowOnError>): RequestResult<GetVotingMethodResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetVotingMethodResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/voting-method',
    ...options
});

/**
 * Update Voting Method
 *
 * Update the current user's default voting method preference.
 *
 * This endpoint allows users to set their voting method preference at any time,
 * even before election data is available. Actual method availability will be
 * validated when user takes specific voting actions (ballot request, PAV enrollment).
 *
 * Note: Validation against current election data has been REMOVED to allow
 * users to set preferences in advance. Election data (polling locations, methods)
 * is typically only available 30-60 days before election day.
 */
export const updateVotingMethod = <ThrowOnError extends boolean = false>(options: Options<UpdateVotingMethodData, ThrowOnError>): RequestResult<UpdateVotingMethodResponses, UpdateVotingMethodErrors, ThrowOnError> => (options.client ?? client).post<UpdateVotingMethodResponses, UpdateVotingMethodErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/voting-method',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Warning Status
 *
 * Get the current user's warning prompt status flags.
 *
 * Returns all status flags used by the frontend to display action prompts:
 * - **is_survey_completed**: Whether user completed the active onboarding survey
 * - **is_persona_verified**: Whether user's identity is verified
 * - **voter_registration_status**: REGISTERED, UNREGISTERED, or NOT_LINKED
 *
 * This endpoint provides a single source of truth for all warning indicators
 * displayed across the application.
 */
export const getWarningStatus = <ThrowOnError extends boolean = false>(options?: Options<GetWarningStatusData, ThrowOnError>): RequestResult<GetWarningStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetWarningStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/me/warning-status',
    ...options
});

/**
 * Map an activist to their VoterBase record by activist_id (links/persists)
 *
 * Look up the activist's voter record from their stored identity/address and LINK
 * it — persisting the matched VoterBase id and voter data onto the account.
 *
 * Unlike the user-facing link flow, this **overwrites** any existing link (no
 * "already linked" restriction), so it can be used to (re)map an activist to the
 * correct VoterBase id. It still refuses to link a record that belongs to a
 * DIFFERENT account (VOTER_ID_ALREADY_EXISTS).
 */
export const mapVoterbaseId = <ThrowOnError extends boolean = false>(options: Options<MapVoterbaseIdData, ThrowOnError>): RequestResult<MapVoterbaseIdResponses, MapVoterbaseIdErrors, ThrowOnError> => (options.client ?? client).post<MapVoterbaseIdResponses, MapVoterbaseIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/voter-record/link/{activist_id}',
    ...options
});

/**
 * Unlink an activist's voter record by activist_id (admin/support)
 *
 * Clear a given activist's voter-record link by id (returns to NOT_ATTEMPTED). Idempotent.
 */
export const unlinkVoterRecordById = <ThrowOnError extends boolean = false>(options: Options<UnlinkVoterRecordByIdData, ThrowOnError>): RequestResult<UnlinkVoterRecordByIdResponses, UnlinkVoterRecordByIdErrors, ThrowOnError> => (options.client ?? client).post<UnlinkVoterRecordByIdResponses, UnlinkVoterRecordByIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/voter-record/unlink/{activist_id}',
    ...options
});

/**
 * Run a voter lookup from an activist's stored address and return the matched VoterBase ID
 *
 * Run the two-stage voter match (v2) using the activist's stored identity and
 * address, and return the matched VoterBase ID.
 *
 * This does NOT persist/link anything — it's a read-only lookup. The match runs
 * against voterbase_vbid_view; on a single match we return the VoterBase ID
 * (`"{STATE}-{individual_id}"`), otherwise the outcome `reason_code`
 * (NO_MATCH / AMBIGUOUS_* / LOOKUP_UNAVAILABLE).
 */
export const lookupVoterbaseId = <ThrowOnError extends boolean = false>(options: Options<LookupVoterbaseIdData, ThrowOnError>): RequestResult<LookupVoterbaseIdResponses, LookupVoterbaseIdErrors, ThrowOnError> => (options.client ?? client).get<LookupVoterbaseIdResponses, LookupVoterbaseIdErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/users/voter-record/voterbase-id/{activist_id}',
    ...options
});

/**
 * Create a Persona inquiry (server-first flow)
 *
 * Creates the Persona inquiry server-side so the template ID never ships in the app. Returns a one-time inquiry_id + session_token for the mobile SDK (Inquiry.fromInquiry / InquiryConfiguration(inquiryId:)).
 */
export const createInquiry = <ThrowOnError extends boolean = false>(options: Options<CreateInquiryData, ThrowOnError>): RequestResult<CreateInquiryResponses, CreateInquiryErrors, ThrowOnError> => (options.client ?? client).post<CreateInquiryResponses, CreateInquiryErrors, ThrowOnError>({
    url: '/activist-arc/verification/create-inquiry',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get current user's verification status
 *
 * Get the verification status for the currently authenticated user.
 */
export const getCurrentVerificationStatus = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentVerificationStatusData, ThrowOnError>): RequestResult<GetCurrentVerificationStatusResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetCurrentVerificationStatusResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/verification/status',
    ...options
});

/**
 * Confirm identity verification
 *
 * Confirm verification after completing the Persona SDK flow. The mobile app sends the inquiry_id and activist_id, and backend verifies it with Persona.
 */
export const verifyIdentity = <ThrowOnError extends boolean = false>(options: Options<VerifyIdentityData, ThrowOnError>): RequestResult<VerifyIdentityResponses, VerifyIdentityErrors, ThrowOnError> => (options.client ?? client).post<VerifyIdentityResponses, VerifyIdentityErrors, ThrowOnError>({
    url: '/activist-arc/verification/verify-identity',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Persona webhook receiver
 *
 * Receives webhook events from Persona for verification status updates.
 */
export const receiveWebhook = <ThrowOnError extends boolean = false>(options?: Options<ReceiveWebhookData, ThrowOnError>): RequestResult<ReceiveWebhookResponses, unknown, ThrowOnError> => (options?.client ?? client).post<ReceiveWebhookResponses, unknown, ThrowOnError>({ url: '/activist-arc/verification/webhook', ...options });

/**
 * Get Voting Module Aggregate
 *
 * Get aggregated data for the Voting Module.
 * Combines:
 * 1. User Profile (enriched with voter ID requirements)
 * 2. Next Election Details (deadlines, locations)
 * 3. Candidates (grouped by race)
 */
export const getVotingModuleAggregate = <ThrowOnError extends boolean = false>(options?: Options<GetVotingModuleAggregateData, ThrowOnError>): RequestResult<GetVotingModuleAggregateResponses, unknown, ThrowOnError> => (options?.client ?? client).get<GetVotingModuleAggregateResponses, unknown, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/activist-arc/voting-module',
    ...options
});

/**
 * Courtlistener Webhook
 *
 * Receive webhook events from CourtListener.
 *
 * Security:
 * - IP allowlisting from known CourtListener IPs
 * - Secret URL path (not /webhook, configured via env)
 * - Idempotency key checking
 *
 * CourtListener webhook event types:
 * - docket.Alert - New filings in subscribed cases
 * - search.Alert - New results matching saved search queries
 * - old_docket_alert - Weekly notifications about dormant cases
 * - recap.fetch.completed - PACER document purchase completion
 * - pray_and_pay - Requested PACER documents now available
 *
 * Always returns 200 to prevent excessive retries from CourtListener.
 */
export const courtlistenerWebhook = <ThrowOnError extends boolean = false>(options?: Options<CourtlistenerWebhookData, ThrowOnError>): RequestResult<CourtlistenerWebhookResponses, CourtlistenerWebhookErrors, ThrowOnError> => (options?.client ?? client).post<CourtlistenerWebhookResponses, CourtlistenerWebhookErrors, ThrowOnError>({ url: '/activist-arc/webhooks/courtlistener/8f3e9b1c2a', ...options });

/**
 * Webhook Health
 *
 * Health check endpoint for webhook system.
 * Public endpoint (no auth required).
 */
export const webhookHealth = <ThrowOnError extends boolean = false>(options?: Options<WebhookHealthData, ThrowOnError>): RequestResult<WebhookHealthResponses, unknown, ThrowOnError> => (options?.client ?? client).get<WebhookHealthResponses, unknown, ThrowOnError>({ url: '/activist-arc/webhooks/courtlistener/webhook/health', ...options });

/**
 * Health Check
 *
 * Health check endpoint for monitoring
 */
export const healthCheckHealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckHealthGetData, ThrowOnError>): RequestResult<HealthCheckHealthGetResponses, unknown, ThrowOnError> => (options?.client ?? client).get<HealthCheckHealthGetResponses, unknown, ThrowOnError>({ url: '/health', ...options });
